/**
 * Customizer Native Loader
 * Loads and renders React customizer components natively in Shopify theme DOM
 */

// Import variant mapping functionality
const SHOPIFY_VARIANT_MAPPING_V2 = {
  poster: {
    "product-1": {
      "13x18 cm": {
        none: "51045613535578",
        white: "51045613568346",
        natural: "51045613601114",
        dark: "51045613633882",
        black: "51045613666650",
      },
      "21x30 cm": {
        none: "51045613863258",
        white: "51045613896026",
        natural: "51045613928794",
        dark: "51045613961562",
        black: "51045613994330",
      },
      "30x40 cm": {
        none: "51045614190938",
        white: "51045614223706",
        natural: "51045614256474",
        dark: "51045614289242",
        black: "51045614322010",
      },
      "40x50 cm": {
        none: "51045615599962",
        white: "51045615632730",
        natural: "51045615665498",
        dark: "51045615698266",
        black: "51045615731034",
      },
      "50x70 cm": {
        none: "51045614518618",
        white: "51045614551386",
        natural: "51045614584154",
        dark: "51045614616922",
        black: "51045614649690",
      },
      "70x100 cm": {
        none: "51045614846298",
        white: "51045614879066",
        natural: "51045614911834",
        dark: "51045614944602",
        black: "51045614977370",
      },
    },
    "product-2": {
      "13x18 cm": {
        none: "52282869023066",
        white: "52282869055834",
        natural: "52282869088602",
        dark: "52282869121370",
        black: "52282869154138",
      },
      "21x30 cm": {
        none: "52282869186906",
        white: "52282869219674",
        natural: "52282869252442",
        dark: "52282869285210",
        black: "52282869317978",
      },
      "30x40 cm": {
        none: "52282869350746",
        white: "52282869383514",
        natural: "52282869416282",
        dark: "52282869449050",
        black: "52282869481818",
      },
      "40x50 cm": {
        none: "52282869514586",
        white: "52282869547354",
        natural: "52282869580122",
        dark: "52282869612890",
        black: "52282869645658",
      },
      "50x70 cm": {
        none: "52282869678426",
        white: "52282869711194",
        natural: "52282869743962",
        dark: "52282869776730",
        black: "52282869809498",
      },
      "70x100 cm": {
        none: "52282869842266",
        white: "52282869875034",
        natural: "52282869907802",
        dark: "52282869940570",
        black: "52282869973338",
      },
    },
    "product-3": {
      "13x18 cm": {
        none: "52285162684762",
        white: "52285162717530",
        natural: "52285162750298",
        dark: "52285162783066",
        black: "52285162815834",
      },
      "21x30 cm": {
        none: "52285162848602",
        white: "52285162881370",
        natural: "52285162914138",
        dark: "52285162946906",
        black: "52285162979674",
      },
      "30x40 cm": {
        none: "52285163012442",
        white: "52285163045210",
        natural: "52285163077978",
        dark: "52285163110746",
        black: "52285163143514",
      },
      "40x50 cm": {
        none: "52285163176282",
        white: "52285163209050",
        natural: "52285163241818",
        dark: "52285163274586",
        black: "52285163307354",
      },
      "50x70 cm": {
        none: "52285163340122",
        white: "52285163372890",
        natural: "52285163405658",
        dark: "52285163438426",
        black: "52285163471194",
      },
      "70x100 cm": {
        none: "52285163503962",
        white: "52285163536730",
        natural: "52285163569498",
        dark: "52285163602266",
        black: "52285163635034",
      },
    },
  },
  canvas: {
    "product-1": {
      "20x25 cm": { none: "51685368856922" },
      "20x30 cm": { none: "51685370757466" },
      "30x40 cm": { none: "51685372658010" },
      "40x50 cm": { none: "51685375934810" },
      "40x60 cm": { none: "52244513718618" },
      "50x70 cm": { none: "51685376852314" },
      "60x80 cm": { none: "51685377835354" },
      "70x100 cm": { none: "51685378326874" },
    },
    "product-2": {
      "20x25 cm": {
        none: "52282870006106",
      },
      "20x30 cm": {
        none: "52282870038874",
      },
      "30x40 cm": {
        none: "52282870071642",
      },
      "40x50 cm": {
        none: "52282870104410",
      },
      "40x60 cm": {
        none: "52282870235482",
      },
      "50x70 cm": {
        none: "52282870137178",
      },
      "60x80 cm": {
        none: "52282870169946",
      },
      "70x100 cm": {
        none: "52282870202714",
      },
    },
    "product-3": {
      "20x25 cm": { none: "52285163667802" },
      "20x30 cm": { none: "52285163700570" },
      "30x40 cm": { none: "52285163733338" },
      "40x50 cm": { none: "52285163766106" },
      "40x60 cm": { none: "52285163897178" },
      "50x70 cm": { none: "52285163798874" },
      "60x80 cm": { none: "52285163831642" },
      "70x100 cm": { none: "52285163864410" },
    },
  },
};

// Product routing table - map Shopify product ID to product key
const PRODUCT_KEY_BY_ID = {
  // Lägg till ditt canvas produkt-ID här:
  // 'DITT_CANVAS_PRODUKT_ID': 'product-2',
  // Alla andra produkter använder 'product-1' som default
  10426530365786: "product-2",
  10427188478298: "product-3",
};

// Legacy mapping for fallback
const SHOPIFY_VARIANT_MAPPING_LEGACY = {
  "13x18 cm": {
    portrait: {
      "Ingen ram": "51045613535578",
      "White frame": "51045613568346",
      "Wood frame": "51045613601114",
      "Dark wood frame": "51045613633882",
      "Black frame": "51045613666650",
    },
    landscape: {
      "Ingen ram": "51045613699418",
      "White frame": "51045613732186",
      "Wood frame": "51045613764954",
      "Dark wood frame": "51045613797722",
      "Black frame": "51045613830490",
    },
  },
  "21x30 cm": {
    portrait: {
      "Ingen ram": "51045613863258",
      "White frame": "51045613896026",
      "Wood frame": "51045613928794",
      "Dark wood frame": "51045613961562",
      "Black frame": "51045613994330",
    },
    landscape: {
      "Ingen ram": "51045614027098",
      "White frame": "51045614059866",
      "Wood frame": "51045614092634",
      "Dark wood frame": "51045614125402",
      "Black frame": "51045614158170",
    },
  },
  "30x40 cm": {
    portrait: {
      "Ingen ram": "51045614190938",
      "White frame": "51045614223706",
      "Wood frame": "51045614256474",
      "Dark wood frame": "51045614289242",
      "Black frame": "51045614322010",
    },
    landscape: {
      "Ingen ram": "51045614354778",
      "White frame": "51045614387546",
      "Wood frame": "51045614420314",
      "Dark wood frame": "51045614453082",
      "Black frame": "51045614485850",
    },
  },
  "40x50 cm": {
    portrait: {
      "Ingen ram": "51045615599962",
      "White frame": "51045615632730",
      "Wood frame": "51045615665498",
      "Dark wood frame": "51045615698266",
      "Black frame": "51045615731034",
    },
    landscape: {
      "Ingen ram": "51045615763802",
      "White frame": "51045615796570",
      "Wood frame": "51045615829338",
      "Dark wood frame": "51045615862106",
      "Black frame": "51045615894874",
    },
  },
  "50x70 cm": {
    portrait: {
      "Ingen ram": "51045614518618",
      "White frame": "51045614551386",
      "Wood frame": "51045614584154",
      "Dark wood frame": "51045614616922",
      "Black frame": "51045614649690",
    },
    landscape: {
      "Ingen ram": "51045614682458",
      "White frame": "51045614715226",
      "Wood frame": "51045614747994",
      "Dark wood frame": "51045614780762",
      "Black frame": "51045614813530",
    },
  },
  "70x100 cm": {
    portrait: {
      "Ingen ram": "51045614846298",
      "White frame": "51045614879066",
      "Wood frame": "51045614911834",
      "Dark wood frame": "51045614944602",
      "Black frame": "51045614977370",
    },
    landscape: {
      "Ingen ram": "51045615010138",
      "White frame": "51045615042906",
      "Wood frame": "51045615075674",
      "Dark wood frame": "51045615108442",
      "Black frame": "51045615141210",
    },
  },
};

function getShopifyVariantId(size, orientation, frame, productType, productKey) {
  // Map frame names from native format to React format
  const frameMapping = {
    "Ingen ram": "none",
    "White frame": "white",
    "Wood frame": "natural",
    "Dark wood frame": "dark",
    "Black frame": "black",
  };

  const normalizedFrame = frameMapping[frame] || frame;

  // Try new structure first (PRODUCT_TYPE -> PRODUCT_KEY -> SIZE -> FRAME)
  if (productType) {
    const productTypeMapping = SHOPIFY_VARIANT_MAPPING_V2[productType];
    if (productTypeMapping) {
      // Use provided productKey or default to 'product-1'
      const key = productKey || "product-1";
      const productMapping = productTypeMapping[key];
      if (productMapping) {
        const sizeMapping = productMapping[size];
        if (sizeMapping) {
          const variantId = sizeMapping[normalizedFrame];
          if (variantId && variantId.trim() !== "") {
            return variantId;
          }
        }
      }
    }
  }

  // Fallback to legacy structure (SIZE -> ORIENTATION -> FRAME)
  const sizeMapping = SHOPIFY_VARIANT_MAPPING_LEGACY[size];
  const orientationMapping = sizeMapping?.[orientation];
  const variantId = orientationMapping?.[frame];

  if (!variantId || variantId.trim() === "") {
    // Try to find any available variant for this size as fallback
    const fallbackVariant = Object.values(sizeMapping || {})
      .flatMap((orientationObj) => Object.values(orientationObj))
      .find((id) => id && id.trim() !== "");

    if (fallbackVariant) {
      return fallbackVariant;
    }

    return "";
  }

  return variantId;
}

class CustomizerNativeLoader {
  constructor() {
    this.reactLoaded = false;
    this.componentInstances = new Map();
    this.designData = {};
    this.customizerState = {
      motifs: [],
      currentMotif: null,
      selectedVariantId: null,
    };

    // Cache for detected option roles per product
    this.productOptionRoles = new Map();
    this.isUpdatingFromCustomizer = false;

    // Add CSS for spinner animation
    this.addSpinnerCSS();

    // Listen for design updates from React components
    this.setupDesignDataSync();

    this.loadReact();
  }

  /**
   * Normalize variant payload to be language-independent
   */
  normalizeVariantPayload(data, productData) {
    console.debug("[CustomizerNativeLoader] Normalizing variant payload:", { data, productData });

    const result = {
      size: null,
      frame: null,
      productType: null,
      orientation: null,
    };

    // If data already has parsed information, use it
    if (data && typeof data === "object") {
      // Handle size normalization
      if (data.size) {
        if (typeof data.size === "string") {
          // Parse size string like "30x40" or "30x40 cm"
          const sizeMatch = data.size.match(/(\d+)\s*[x×xX]\s*(\d+)/);
          if (sizeMatch) {
            const width = parseInt(sizeMatch[1]);
            const height = parseInt(sizeMatch[2]);
            let label = data.size.trim();
            if (!label.includes(" cm")) {
              label = `${label} cm`;
            }
            result.size = { width, height, label };
            result.orientation = width > height ? "landscape" : "portrait";
          }
        } else if (data.size.width && data.size.height) {
          result.size = data.size;
          result.orientation = data.size.width > data.size.height ? "landscape" : "portrait";
        }
      }

      // Handle frame normalization with extended synonyms
      if (data.frame) {
        result.frame = this.normalizeFrameName(data.frame);
      }

      // Handle product type
      if (data.productType) {
        result.productType = data.productType;
      }

      // Override orientation if explicitly provided
      if (data.orientation) {
        result.orientation = data.orientation;
      }
    }

    console.debug("[CustomizerNativeLoader] Normalized payload result:", result);
    return result;
  }

  /**
   * Normalize frame names to internal keys with extended language support
   */
  normalizeFrameName(frameName) {
    if (!frameName || typeof frameName !== "string") return "none";

    const frame = frameName.toLowerCase().trim();

    // No frame variations (en/sv/de/fr/es)
    if (
      frame.includes("no frame") ||
      frame.includes("utan ram") ||
      frame.includes("ingen ram") ||
      frame.includes("kein rahmen") ||
      frame.includes("sans cadre") ||
      frame.includes("sin marco") ||
      frame.includes("none") ||
      frame.includes("no") ||
      frame.includes("nej")
    ) {
      return "none";
    }

    // White frame variations
    if (
      frame.includes("white") ||
      frame.includes("vit") ||
      frame.includes("weiß") ||
      frame.includes("weiss") ||
      frame.includes("blanc") ||
      frame.includes("blanco")
    ) {
      return "white";
    }

    // Natural/Wood frame variations (including "wooden frame")
    if (
      frame.includes("wood") ||
      frame.includes("wooden") ||
      frame.includes("natural") ||
      frame.includes("naturlig") ||
      frame.includes("natur") ||
      frame.includes("holz") ||
      frame.includes("bois") ||
      frame.includes("madera")
    ) {
      return "natural";
    }

    // Dark wood frame variations
    if (
      frame.includes("dark wood") ||
      frame.includes("dark") ||
      frame.includes("mörk") ||
      frame.includes("dunkel") ||
      frame.includes("sombre") ||
      frame.includes("oscuro")
    ) {
      return "dark";
    }

    // Black frame variations
    if (
      frame.includes("black") ||
      frame.includes("svart") ||
      frame.includes("schwarz") ||
      frame.includes("noir") ||
      frame.includes("negro")
    ) {
      return "black";
    }

    return "with-frame"; // Default fallback
  }

  addSpinnerCSS() {
    if (document.getElementById("customizer-spinner-css")) return;

    const style = document.createElement("style");
    style.id = "customizer-spinner-css";
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      
      .customizer-spinner {
        width: 16px;
        height: 16px;
        display: inline-block;
        animation: spin 1s linear infinite;
      }
      
      .generating-status {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #666;
        font-size: 14px;
      }
      
      .customizer-loading-safe {
        opacity: 0.8;
        pointer-events: none;
      }
    `;
    document.head.appendChild(style);
  }

  createSpinnerSVG() {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("width", "16");
    svg.setAttribute("height", "16");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("fill", "none");
    svg.className = "customizer-spinner";

    const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    circle.setAttribute("cx", "12");
    circle.setAttribute("cy", "12");
    circle.setAttribute("r", "10");
    circle.setAttribute("stroke", "#3b82f6");
    circle.setAttribute("stroke-width", "2");
    circle.setAttribute("stroke-linecap", "round");
    circle.setAttribute("stroke-dasharray", "31.416");
    circle.setAttribute("stroke-dashoffset", "31.416");
    circle.style.animation = "spin 1s linear infinite";

    svg.appendChild(circle);
    return svg;
  }

  async loadReact() {
    if (window.React && window.ReactDOM) {
      this.reactLoaded = true;
      this.initializeComponents();
      return;
    }

    try {
      // Load React and ReactDOM from CDN
      await this.loadScript("https://unpkg.com/react@18/umd/react.production.min.js");
      await this.loadScript("https://unpkg.com/react-dom@18/umd/react-dom.production.min.js");

      this.reactLoaded = true;
      this.initializeComponents();
    } catch (error) {
      console.error("[CustomizerNativeLoader] Failed to load React:", error);
      // Show error message in containers
      this.showLoadError();
    }
  }

  showLoadError() {
    const containers = document.querySelectorAll("[data-block-type]");
    containers.forEach((container) => {
      const loadingEl = container.querySelector(
        ".customizer-controls-loading, .ai-generator-loading, .product-config-loading, .customizer-loading",
      );
      if (loadingEl) {
        loadingEl.innerHTML = '<p style="color: #dc2626;">Failed to load customizer. Please refresh the page.</p>';
      }
    });
  }

  loadScript(src) {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  initializeComponents() {
    // Define React components for each block type
    this.defineComponents();

    // Initialize price synchronization for customizer products
    this.initializePriceSynchronization();

    // Auto-mount any blocks present in the DOM (works even if bridge gating fails)
    const mountExisting = () => {
      const nodes = document.querySelectorAll("[data-block-type]");
      nodes.forEach((el) => {
        const blockId = el.id;
        const blockType = el.dataset.blockType;
        if (!blockId || !blockType) return;
        if (this.componentInstances.has(blockId)) return; // already mounted

        const props = {
          productId: el.dataset.productId,
          selectedVariantId: el.dataset.selectedVariant,
          shopDomain: el.dataset.shopDomain,
          onUpdate: () => {},
        };

        try {
          this.renderBlock(blockId, blockType, props);
        } catch (e) {
          console.debug("[CustomizerNativeLoader] Failed to auto-mount block", blockId, e);
        }
      });
    };

    // Mount immediately
    mountExisting();

    // Observe future DOM changes to mount dynamically added blocks
    try {
      if (!this._mountObserver) {
        this._mountObserver = new MutationObserver(() => mountExisting());
        this._mountObserver.observe(document.body, { childList: true, subtree: true });
      }
    } catch (_) {}
  }

  initializePriceSynchronization() {
    const tryInit = () => {
      try {
        // Try multiple selectors to find product JSON more reliably
        const productJsonElement = document.querySelector(
          '#product-json-inline[data-product-json], #product-json[data-product-json], script[type="application/json"][data-product-json], #product-json',
        );
        // Get product data from JSON script (robust)
        const productJsonEl = productJsonElement || document.getElementById("product-json");
        if (!productJsonEl || !productJsonEl.textContent) {
          return false; // Not ready yet
        }

        try {
          this.productData = JSON.parse(productJsonEl.textContent);
        } catch (e) {
          console.error("[CustomizerNativeLoader] Failed parsing product JSON", e);
          return false;
        }

        this.isUpdatingFromCustomizer = false; // Flag to prevent infinite loops
        console.debug("[CustomizerNativeLoader] Initialized price sync for product:", this.productData.id);

        // Listen for customizer variant changes (both colon and hyphen styles)
        const onVariantChange = (event) => {
          if (this.isUpdatingFromCustomizer) {
            console.debug("[CustomizerNativeLoader] Skipping variant change to prevent loop");
            return;
          }

          // Normalize the event data before processing
          const normalizedData = this.normalizeVariantPayload(event.detail, this.productData);
          console.debug("[CustomizerNativeLoader] Processing variant change with normalized data:", normalizedData);

          this.updateNativePrice(normalizedData);
        };
        document.addEventListener("customizer:variant:change", onVariantChange);
        document.addEventListener("customizer:variant-change", onVariantChange);

        return true; // Success
      } catch (error) {
        console.error("[CustomizerNativeLoader] Failed to initialize price sync:", error);
        return false;
      }
    };

    // Try immediate initialization
    if (tryInit()) {
      return;
    }

    // If not ready, set up multiple fallbacks to detect product JSON
    console.debug("[CustomizerNativeLoader] Product JSON not ready, setting up observers and retries...");

    // 1) DOMContentLoaded fallback
    const onReady = () => {
      tryInit();
      document.removeEventListener("DOMContentLoaded", onReady);
    };
    document.addEventListener("DOMContentLoaded", onReady);

    // 2) Observe body for late-inserted product JSON
    let retryCount = 0;
    const maxRetries = 20;
    const observer = new MutationObserver(() => {
      if (tryInit()) {
        observer.disconnect();
        return;
      }
      retryCount++;
      if (retryCount >= maxRetries) {
        console.debug("[CustomizerNativeLoader] Max retries reached for product JSON (observer)");
        observer.disconnect();
      }
    });
    try {
      observer.observe(document.body, { childList: true, subtree: true });
    } catch (_) {}

    // 3) Timed retries as last resort
    let tries = 0;
    const interval = setInterval(() => {
      if (tryInit()) {
        clearInterval(interval);
        observer.disconnect?.();
      } else if (++tries >= maxRetries) {
        clearInterval(interval);
        observer.disconnect?.();
        console.debug("[CustomizerNativeLoader] Max timed retries reached for product JSON");
      }
    }, 500);
  }

  updateNativePrice(customizerData) {
    if (!this.productData || !customizerData) return;

    // Set flag to prevent bridge from re-triggering
    this.isUpdatingFromCustomizer = true;

    try {
      // Normalize payload to be language-independent
      const normalizedPayload = this.normalizeVariantPayload(customizerData, this.productData);

      // Find matching Shopify variant based on normalized selection
      const matchingVariant = this.findMatchingVariant(normalizedPayload);

      if (matchingVariant) {
        // Update native variant selector to trigger theme's price update
        this.updateVariantSelector(matchingVariant.id);

        // Update the selected variant JSON script
        this.updateSelectedVariantJson(matchingVariant);

        // Update theme price display directly
        this.updateThemePrice(matchingVariant);

        // Trigger Shopify theme's product info rendering
        this.triggerThemeProductInfoUpdate(matchingVariant);

        // Dispatch separate events for compatibility with React components
        if (normalizedPayload.productType) {
          document.dispatchEvent(
            new CustomEvent("customizer:product:type-change", {
              detail: { to: normalizedPayload.productType, __fromLoader: true },
            }),
          );
        }

        if (normalizedPayload.orientation) {
          document.dispatchEvent(
            new CustomEvent("customizer:orientation:change", {
              detail: { to: normalizedPayload.orientation, __fromLoader: true },
            }),
          );
        }

        console.debug(
          "[CustomizerNativeLoader] Updated variant and triggered theme price update for variant:",
          matchingVariant.id,
          "with normalized payload:",
          normalizedPayload,
        );
      }
    } catch (error) {
      console.error("[CustomizerNativeLoader] Failed to update native price:", error);
    } finally {
      // Always reset flag
      setTimeout(() => {
        this.isUpdatingFromCustomizer = false;
      }, 100);
    }
  }

  findMatchingVariant(customizerData) {
    const { productType, size, frame, orientation = "portrait" } = customizerData;

    if (!this.productData || !this.productData.variants) {
      console.warn(
        "[CustomizerNativeLoader] No product data available for variant matching, trying to parse product JSON on-the-fly",
      );
      try {
        const el = document.querySelector(
          '#product-json-inline[data-product-json], #product-json[data-product-json], script[type="application/json"][data-product-json], #product-json',
        );
        if (el && el.textContent) {
          this.productData = JSON.parse(el.textContent);
        }
      } catch (e) {
        console.debug("[CustomizerNativeLoader] On-the-fly product JSON parse failed", e);
      }
      if (!this.productData || !this.productData.variants) {
        return null;
      }
    }

    // Local helpers for normalization
    const normalizeSizeLabel = (label) => {
      if (!label) return "";
      let s = String(label).trim();
      // Normalize spacing around 'x'
      s = s.replace(/(\d+)\s*x\s*(\d+(?:\.\d+)?)/i, (_, a, b) => `${a}x${b}`);
      // Ensure ' cm' suffix
      if (/cm$/i.test(s)) {
        s = s.replace(/\s*cm$/i, " cm");
        return s;
      }
      if (/^\d+\s*x\s*\d+(?:\.\d+)?$/i.test(s)) {
        return s + " cm";
      }
      return s;
    };
    const normalizeFrameName = (val) => {
      const raw = (val || "").toString().trim();
      const lc = raw.toLowerCase();

      // 1) Support for React Customizer internal keys (lower case)
      const fromKeys = {
        none: "Ingen ram",
        white: "White frame",
        natural: "Wood frame",
        dark: "Dark wood frame",
        black: "Black frame",
      };
      if (fromKeys[lc]) return fromKeys[lc];

      // 2) Support for Shopify/display names (case-insensitive)
      const shopifyToDisplay = {
        "ingen ram": "Ingen ram",
        "no frame": "Ingen ram",
        "utan ram": "Ingen ram",
        "white frame": "White frame",
        "wood frame": "Wood frame",
        "natural frame": "Wood frame",
        "dark wood frame": "Dark wood frame",
        "black frame": "Black frame",
      };
      if (shopifyToDisplay[lc]) return shopifyToDisplay[lc];

      // 3) If raw string already looks correct (exact display)
      const displaySet = new Set(["Ingen ram", "White frame", "Wood frame", "Dark wood frame", "Black frame"]);
      if (displaySet.has(raw)) return raw;

      // 4) Fallback
      return "Ingen ram";
    };

    const sizeLabelRaw = size?.label || size;
    const normalized = {
      productType: (productType || "poster").toString().trim().toLowerCase(),
      sizeLabel: normalizeSizeLabel(sizeLabelRaw),
      frame: normalizeFrameName(frame),
      orientation,
    };

    console.debug("[CustomizerNativeLoader] Looking for variant using mapping:", {
      productType: normalized.productType,
      size: normalized.sizeLabel,
      frame: normalized.frame,
      orientation: normalized.orientation,
      availableSizes: Object.keys(SHOPIFY_VARIANT_MAPPING_V2[normalized.productType] || {}),
    });

    // Determine product key based on current product ID
    const productKey = PRODUCT_KEY_BY_ID[this.productData.id] || "product-1";

    console.debug("[CustomizerNativeLoader] Using product key:", productKey, "for product ID:", this.productData.id);

    // Get the variant ID from our mapping system
    const variantId = getShopifyVariantId(
      normalized.sizeLabel,
      normalized.orientation,
      normalized.frame,
      normalized.productType,
      productKey,
    );

    console.debug("[CustomizerNativeLoader] getShopifyVariantId result:", {
      variantId,
      size: normalized.sizeLabel,
      orientation: normalized.orientation,
      frame: normalized.frame,
      productType: normalized.productType,
      productKey,
    });

    if (!variantId) {
      const availableSizes = Object.keys(SHOPIFY_VARIANT_MAPPING_V2[normalized.productType] || {});
      const availableFrames = Object.keys(
        SHOPIFY_VARIANT_MAPPING_V2[normalized.productType]?.[normalized.sizeLabel] || {},
      );
      console.warn("[CustomizerNativeLoader] No variant ID found in mapping for:", {
        sizeLabel: normalized.sizeLabel,
        frame: normalized.frame,
        productType: normalized.productType,
        orientation: normalized.orientation,
        availableSizes,
        availableFrames,
      });
      return null;
    }

    console.debug("[CustomizerNativeLoader] Found variant ID from mapping:", variantId);

    // Find the actual variant object with price info
    const variant = this.productData.variants.find((v) => v.id.toString() === variantId.toString());

    if (variant) {
      console.debug("[CustomizerNativeLoader] Found variant with price:", {
        id: variant.id,
        price: variant.price,
        formatted_price: variant.formatted_price,
        available: variant.available,
      });
      return variant;
    }

    console.warn("[CustomizerNativeLoader] Variant not found in product data:", variantId, {
      productVariantIds: this.productData.variants.map((v) => v.id),
    });
    return null;
  }

  updatePriceElement(variant) {
    // Find price element using common Shopify selectors
    const priceSelectors = [
      `#Price-template--${this.getCurrentSectionId()}__main-product-${this.productData.id}`,
      ".price__regular .price-item--regular",
      ".product__price .price",
      ".price",
      ".product-form__price .price",
    ];

    let priceElement = null;
    for (const selector of priceSelectors) {
      priceElement = document.querySelector(selector);
      if (priceElement) break;
    }

    if (priceElement && variant.price) {
      // Format price according to Shopify money format
      const formattedPrice = variant.formatted_price || this.formatPrice(variant.price);
      priceElement.textContent = formattedPrice;
      console.debug("[CustomizerNativeLoader] Updated price element to:", formattedPrice);
    }

    // Update the selected variant JSON script that Shopify uses
    this.updateSelectedVariantJson(variant);
  }

  updateSelectedVariantJson(variant) {
    const variantScript = document.getElementById("selected-variant-json");
    if (variantScript) {
      const variantData = {
        id: variant.id,
        price: variant.price,
        formatted_price: variant.formatted_price,
        available: variant.available,
        option1: variant.option1,
        option2: variant.option2,
        option3: variant.option3,
        featured_image: variant.featured_image,
        compare_at_price: variant.compare_at_price,
        formatted_compare_at_price: variant.formatted_compare_at_price,
      };

      variantScript.textContent = JSON.stringify(variantData);
      console.debug("[CustomizerNativeLoader] Updated selected variant JSON:", variantData);

      // Trigger theme product info update BEFORE variant change event
      this.triggerThemeProductInfoUpdate(variantData);

      // Update variant form elements directly and trigger theme price update
      try {
        // Update variant selector inputs
        const variantInputs = document.querySelectorAll('input[name="id"], select[name="id"]');
        let variantChanged = false;

        variantInputs.forEach((input) => {
          if (input.value !== variantData.id.toString()) {
            input.value = variantData.id.toString();
            input.dispatchEvent(new Event("change", { bubbles: true }));
            variantChanged = true;
          }
        });

        // Update price display elements directly
        const priceElements = document.querySelectorAll("[data-price], .price, .product-price");
        priceElements.forEach((el) => {
          if (variantData.price) {
            // Use Shopify's currency formatting if available, fallback to hardcoded format
            let formattedPrice;
            if (window.theme && window.theme.Currency && window.theme.settings) {
              const format = window.theme.settings.currencyCodeEnabled
                ? window.theme.settings.moneyWithCurrencyFormat
                : window.theme.settings.moneyFormat;
              formattedPrice = window.theme.Currency.formatMoney(variantData.price, format);
            } else {
              // Fallback to hardcoded format
              formattedPrice = new Intl.NumberFormat("sv-SE", {
                style: "currency",
                currency: "SEK",
                maximumFractionDigits: 0,
              }).format(variantData.price / 100);
            }

            if (el.textContent !== formattedPrice) {
              el.textContent = formattedPrice;
            }
          }
        });

        // Trigger standard Shopify variant change event
        document.dispatchEvent(
          new CustomEvent("variant:change", {
            detail: { variant: variantData },
          }),
        );

        console.debug(
          "[CustomizerNativeLoader] Updated variant selector and price display for variant:",
          variantData.id,
        );
      } catch (error) {
        console.error("[CustomizerNativeLoader] Error updating variant:", error);
      }

      // Backup trigger after event
      setTimeout(() => {
        this.triggerThemeProductInfoUpdate(variantData);
      }, 100);
    }
  }

  triggerThemeProductInfoUpdate(variant) {
    // Try to trigger Concept theme's product info rendering
    if (window.theme && window.theme.product && window.theme.product.renderProductInfo) {
      window.theme.product.renderProductInfo(variant);
      console.debug("[CustomizerNativeLoader] Triggered theme product info update");
      return;
    }

    // Generic approach: dispatch events that most themes listen to
    const events = [
      new CustomEvent("product:variant:change", { detail: { variant } }),
      new CustomEvent("shopify:variant:change", { detail: { variant } }),
      new CustomEvent("theme:variant:change", { detail: { variant } }),
    ];

    events.forEach((event) => {
      document.dispatchEvent(event);
      window.dispatchEvent(event);
    });

    console.debug("[CustomizerNativeLoader] Dispatched generic variant change events");
  }

  // Direct price update method for theme compatibility
  updateThemePrice(variant) {
    try {
      // Format prices using Shopify's currency system
      const formatPrice = (price) => {
        if (window.theme && window.theme.Currency && window.theme.settings) {
          const format = window.theme.settings.currencyCodeEnabled
            ? window.theme.settings.moneyWithCurrencyFormat
            : window.theme.settings.moneyFormat;
          return window.theme.Currency.formatMoney(price, format);
        } else {
          // Fallback to hardcoded format
          return new Intl.NumberFormat("sv-SE", {
            style: "currency",
            currency: "SEK",
            maximumFractionDigits: 0,
          }).format(price / 100);
        }
      };

      const hasCompareAtPrice = variant.compare_at_price && variant.compare_at_price > variant.price;

      // Find the main price container
      const priceContainer = document.querySelector(".product__price .price, .price");

      if (priceContainer) {
        // Clear existing content
        priceContainer.innerHTML = "";

        if (hasCompareAtPrice) {
          // On sale - create the sale price structure
          priceContainer.className =
            "price price--on-sale flex flex-wrap items-baseline gap-2 lg:flex-col xl:items-end lg:gap-1d5";

          priceContainer.innerHTML = `
            <span class="sr-only">Reapris</span>
            <span class="price__regular White framespace-nowrap">${formatPrice(variant.price)}</span>
            <span class="sr-only">Ordinarie pris</span>
            <span class="price__sale inline-flex items-center h-auto relative">${formatPrice(variant.compare_at_price)}</span>
          `;
        } else {
          // Regular price - no sale
          priceContainer.className = "price";
          priceContainer.innerHTML = `<span class="price__regular">${formatPrice(variant.price)}</span>`;
        }

        console.debug("[CustomizerNativeLoader] Updated price structure, on sale:", hasCompareAtPrice);
      } else {
        // Fallback: update any price elements found
        const priceSelectors = [
          ".price",
          ".product-price",
          ".product__price",
          "[data-price]",
          ".price-item",
          ".money",
          ".product-form__price",
        ];

        let priceUpdated = false;

        priceSelectors.forEach((selector) => {
          const elements = document.querySelectorAll(selector);
          elements.forEach((el) => {
            if (variant.price && (el.textContent.includes("kr") || el.textContent.includes("SEK"))) {
              const formattedPrice = formatPrice(variant.price);

              if (el.textContent !== formattedPrice) {
                el.textContent = formattedPrice;
                priceUpdated = true;
              }
            }
          });
        });

        if (priceUpdated) {
          console.debug("[CustomizerNativeLoader] Updated fallback price elements");
        }
      }

      // Also trigger any theme-specific price update functions
      if (window.theme && window.theme.ProductForm) {
        window.theme.ProductForm.updatePrice?.();
      }
    } catch (error) {
      console.error("[CustomizerNativeLoader] Error updating theme price:", error);
    }
  }

  updateVariantSelector(variantId) {
    // Find variant selector in cart form
    const cartForm = document.querySelector('form[action*="/cart/add"]');
    if (!cartForm) {
      console.debug("[CustomizerNativeLoader] No cart form found");
      return;
    }

    // Look for the main variant ID input/select
    const variantInput = cartForm.querySelector('[name="id"]');
    if (!variantInput) {
      console.debug("[CustomizerNativeLoader] No variant input found in cart form");
      return;
    }

    console.debug("[CustomizerNativeLoader] Updating variant selector to:", variantId);

    if (variantInput.tagName === "SELECT") {
      variantInput.value = variantId;
    } else if (variantInput.tagName === "INPUT") {
      if (variantInput.type === "hidden") {
        variantInput.value = variantId;
      } else if (variantInput.type === "radio") {
        // Uncheck all radio buttons first
        const allRadios = cartForm.querySelectorAll('input[name="id"][type="radio"]');
        allRadios.forEach((radio) => (radio.checked = false));

        // Check the matching radio
        const targetRadio = cartForm.querySelector(`input[name="id"][value="${variantId}"]`);
        if (targetRadio) {
          targetRadio.checked = true;
        }
      }
    }

    // Dispatch change event to trigger theme's own price update logic
    variantInput.dispatchEvent(new Event("change", { bubbles: true }));
    console.debug("[CustomizerNativeLoader] Dispatched change event for variant selector");
  }

  getCurrentSectionId() {
    // Get section ID from page context
    const section = document.querySelector('[id^="shopify-section-template--"]');
    if (section) {
      const match = section.id.match(/template--(\d+)__(.+)/);
      return match ? match[0] : "";
    }
    return "";
  }

  formatPrice(priceInCents) {
    // Simple price formatting - can be enhanced based on shop's money format
    const price = priceInCents / 100;
    return `${price.toFixed(2)} kr`; // Adjust currency as needed
  }

  defineComponents() {
    const { React, ReactDOM } = window;
    const { useState, useEffect, useCallback } = React;
    const loader = this;

    // Canvas Component
    this.CanvasComponent = function ({ productId, selectedVariantId, shopDomain, onUpdate }) {
      const [isLoading, setIsLoading] = useState(true);
      const [canvasReady, setCanvasReady] = useState(false);

      // Canvas mounting with MutationObserver for robustness
      useEffect(() => {
        const iframe = document.createElement("iframe");
        const base = window.CUSTOMIZER_APP_URL || "https://art-design-visualizer.lovable.app/customize-embed";
        let url;
        try {
          url = new URL(base, window.location.origin);
        } catch (_) {
          url = new URL("https://art-design-visualizer.lovable.app/customize-embed");
        }

        // Add embed_only parameter for iframe-only mode
        url.searchParams.set("embed_only", "true");
        console.debug("[CustomizerNativeLoader] iframe URL", {
          url: url.toString(),
          productId,
          selectedVariantId,
          shopDomain,
        });
        if (productId) url.searchParams.set("product_id", String(productId));
        if (selectedVariantId) url.searchParams.set("selected_variant", String(selectedVariantId));
        const shop = (window.Shopify && window.Shopify.shop) || shopDomain;
        if (shop) url.searchParams.set("shop", shop);
        url.searchParams.set("native", "true");

        iframe.src = url.toString();
        iframe.style.width = "100%";
        iframe.style.height = "400px"; // Initial height
        iframe.style.border = "none";
        iframe.style.borderRadius = "8px";
        iframe.style.transition = "height 0.3s ease"; // Smooth height transitions
        iframe.style.overflow = "hidden"; // Prevent scrollbars
        iframe.scrolling = "no"; // Additional scrollbar prevention

        const tryFindAndAttach = () => {
          // Robust container finding
          const selectors = [
            `#customizer-canvas-${productId}`,
            '[data-block-type="customizer-canvas"]',
            '.customizer-canvas-wrapper [data-block-type="customizer-canvas"]',
            '[data-customizer-slot] [data-block-type="customizer-canvas"]',
          ];

          for (const selector of selectors) {
            const container = document.querySelector(selector);
            if (container) {
              container.innerHTML = "";
              container.appendChild(iframe);
              // mark active for CSS-guard
              document.body.setAttribute("data-customizer-active", "true");
              const containerWithGallery =
                container.closest(".product__gallery-container") ||
                document.querySelector(".product__gallery-container");
              containerWithGallery?.setAttribute("data-customizer-active", "true");

              setIsLoading(false);
              setCanvasReady(true);
              return true;
            }
          }
          return false;
        };

        // Try immediate attachment
        if (tryFindAndAttach()) {
          return; // Success
        }

        // Use MutationObserver to wait for container
        console.debug("[CustomizerNativeLoader] Container not found immediately, watching for it...");
        const observer = new MutationObserver(() => {
          if (tryFindAndAttach()) {
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });

        // Timeout after 10 seconds
        const timeout = setTimeout(() => {
          observer.disconnect();
          if (!canvasReady) {
            console.warn("[CustomizerNativeLoader] Canvas container not found after waiting");
          }
        }, 10000);

        return () => {
          observer.disconnect();
          clearTimeout(timeout);
        };
      }, [productId, selectedVariantId, shopDomain]);

      // Listen for iframe content loaded and add support for new block types
      useEffect(() => {
        // Listen for variant changes and customizer variant picker events
        const handleVariantChange = (event) => {
          console.debug("[CustomizerNativeLoader] Handling variant change event:", event.type, event.detail);

          // Update price based on customizer changes with enhanced logging
          if (event.detail && (event.detail.size || event.detail.frame || event.detail.productType)) {
            console.debug("[CustomizerNativeLoader] Triggering price update for variant change:", event.detail);

            // Normalize the data before processing
            const normalizedData = loader.normalizeVariantPayload(event.detail, loader.productData);
            console.debug("[CustomizerNativeLoader] Using normalized data for price update:", normalizedData);

            loader.updateNativePrice(normalizedData);
          }

          if (canvasReady) {
            // Find iframe
            const selectors = [
              `#customizer-canvas-${productId} iframe`,
              '[data-block-type="customizer-canvas"] iframe',
              ".customizer-canvas-wrapper iframe",
              ".customizer-canvas-native iframe",
            ];

            let iframe = null;
            for (const selector of selectors) {
              iframe = document.querySelector(selector);
              if (iframe) break;
            }

            if (iframe && iframe.contentWindow) {
              // Handle different event types
              const messageData = {
                type: event.type.replace("customizer:", ""),
                ...event.detail,
              };

              iframe.contentWindow.postMessage(messageData, "*");
              console.debug("[CustomizerNativeLoader] postMessage to iframe:", messageData);
            }
          }
        };

        // Listen for iframe resize messages and variant picker messages
        const handleMessage = (event) => {
          console.debug("[CustomizerNativeLoader] Received message:", event.data, "from:", event.origin);

          if (event.data.type === "customizer:resize" && event.data.productId === productId) {
            console.debug("[CustomizerNativeLoader] Received resize message:", event.data);

            // Find iframe more robustly
            const selectors = [
              `#customizer-canvas-${productId} iframe`,
              '[data-block-type="customizer-canvas"] iframe',
              ".customizer-canvas-wrapper iframe",
              ".customizer-canvas-native iframe",
            ];

            let iframe = null;
            for (const selector of selectors) {
              iframe = document.querySelector(selector);
              if (iframe) break;
            }

            if (iframe) {
              const newHeight = Math.max(event.data.height, 200); // Minimum height
              iframe.style.height = `${newHeight}px`;
              iframe.style.transition = "height 0.3s ease";
              console.debug("[CustomizerNativeLoader] Updated iframe height to:", newHeight + "px");

              // Also update container
              const container = iframe.closest('[data-block-type="customizer-canvas"]');
              if (container) {
                container.style.minHeight = `${newHeight}px`;
              }
            } else {
              console.debug("[CustomizerNativeLoader] Could not find iframe to resize");
            }
          }

          // Handle variant picker messages and forward to iframe
          if (
            event.data.type === "variant:change" ||
            event.data.type === "product:type-change" ||
            event.data.type === "orientation:change"
          ) {
            console.debug("[CustomizerNativeLoader] Handling variant picker message:", event.data);

            // Update price based on message data with enhanced logging
            if (event.data && (event.data.size || event.data.frame || event.data.productType)) {
              console.debug("[CustomizerNativeLoader] Triggering price update from message:", event.data);

              // Normalize the data before processing
              const normalizedData = loader.normalizeVariantPayload(event.data, loader.productData);
              console.debug("[CustomizerNativeLoader] Using normalized data for price update:", normalizedData);

              loader.updateNativePrice(normalizedData);
            }

            // Normalize event type by stripping "block:" prefix
            let normalizedType = event.data.type;
            if (normalizedType.startsWith("block:")) {
              normalizedType = normalizedType.replace("block:", "");
            }

            const normalizedData = {
              ...event.data,
              type: normalizedType,
            };

            // Find and send to customizer iframe
            const selectors = [
              `#customizer-canvas-${productId} iframe`,
              '[data-block-type="customizer-canvas"] iframe',
              ".customizer-canvas-wrapper iframe",
              ".customizer-canvas-native iframe",
            ];

            let iframe = null;
            for (const selector of selectors) {
              iframe = document.querySelector(selector);
              if (iframe) break;
            }

            if (iframe && iframe.contentWindow) {
              iframe.contentWindow.postMessage(normalizedData, "*");
              console.debug(
                "[CustomizerNativeLoader] Successfully forwarded normalized message to iframe:",
                normalizedData,
              );
            } else {
              console.warn("[CustomizerNativeLoader] Could not find iframe to forward message");
            }
          }

          // Handle design data updates from iframe
          if (event.data.type === "design-update") {
            console.debug("[CustomizerNativeLoader] Received design update from iframe:", event.data);
            loader.updateDesignData(event.data);
          }

          // Handle messages from iframe for AI and controls
          if (event.data.type === "ai:generated" && event.data.imageUrl) {
            console.debug("[CustomizerNativeLoader] AI image generated:", event.data.imageUrl);
            // Notify AI Generator component
            const aiBlock = document.querySelector('[data-block-type="ai-image-generator"]');
            if (aiBlock) {
              const customEvent = new CustomEvent("ai:response", {
                detail: {
                  success: true,
                  imageUrl: event.data.imageUrl,
                  generationId: event.data.generationId,
                },
              });
              aiBlock.dispatchEvent(customEvent);
            }
          }

          if (event.data.type === "ai:error") {
            console.debug("[CustomizerNativeLoader] AI generation error:", event.data.error);
            const aiBlock = document.querySelector('[data-block-type="ai-image-generator"]');
            if (aiBlock) {
              const customEvent = new CustomEvent("ai:response", {
                detail: {
                  success: false,
                  error: event.data.error,
                  generationId: event.data.generationId,
                },
              });
              aiBlock.dispatchEvent(customEvent);
            }
          }
        };

        // Listen for various customizer events
        document.addEventListener("block:variant:change", handleVariantChange);
        document.addEventListener("customizer:variant:change", handleVariantChange);
        document.addEventListener("customizer:product:type-change", handleVariantChange);
        document.addEventListener("customizer:orientation:change", handleVariantChange);
        window.addEventListener("message", handleMessage);

        return () => {
          document.removeEventListener("block:variant:change", handleVariantChange);
          document.removeEventListener("customizer:variant:change", handleVariantChange);
          document.removeEventListener("customizer:product:type-change", handleVariantChange);
          document.removeEventListener("customizer:orientation:change", handleVariantChange);
          window.removeEventListener("message", handleMessage);
        };
      }, [selectedVariantId, canvasReady, productId]);

      if (isLoading) {
        return React.createElement(
          "div",
          {
            className: "customizer-loading",
            style: {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "400px",
            },
          },
          React.createElement("div", {
            style: {
              width: "40px",
              height: "40px",
              border: "3px solid #e0e0e0",
              borderTop: "3px solid #333",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            },
          }),
        );
      }

      return React.createElement("div", {
        className: "customizer-canvas-native",
        style: { width: "100%", minHeight: "400px" },
      });
    };

    // AI Generator Component
    this.AIGeneratorComponent = function ({ productId, onUpdate }) {
      const [prompt, setPrompt] = useState("");
      const [theme, setTheme] = useState("");
      const [orientation, setOrientation] = useState("portrait");
      const [generatedImage, setGeneratedImage] = useState(null);
      const [isGenerating, setIsGenerating] = useState(false);
      const [error, setError] = useState(null);
      const [cachedImages, setCachedImages] = useState([]);
      const [loadingCached, setLoadingCached] = useState(true);
      const [generationId, setGenerationId] = useState(null);

      // Get schema texts from data attributes (support both ai-generator and ai-image-generator)
      const container = document.querySelector(
        `[data-product-id="${productId}"][data-block-type="ai-generator"], [data-product-id="${productId}"][data-block-type="ai-image-generator"]`,
      );
      const generateButtonText = container?.dataset.generateButtonText || "Generate Image";
      const generatingText = container?.dataset.generatingText || "Generating...";
      const promptPlaceholder = container?.dataset.promptPlaceholder || "Describe the image you want to generate...";
      const addToEditorText = container?.dataset.addToEditorText || "Add to Editor";
      const errorText = container?.dataset.errorText || "Error generating image. Please try again.";
      const previousImagesText = container?.dataset.previousImagesText || "Previous Images";
      const themeLabel = container?.dataset.themeLabel || "Style";
      const themePlaceholder = container?.dataset.themePlaceholder || "Select a style...";
      const showStyleOptions = container?.dataset.showStyleOptions !== "false"; // Default to true unless explicitly false
      const orientationLabel = container?.dataset.orientationLabel || "Orientering";
      const orientationPortraitText = container?.dataset.orientationPortraitText || "Porträtt";
      const orientationLandscapeText = container?.dataset.orientationLandscapeText || "Landskap";

      // Define available themes/styles
      const parseCustomStyles = (csv) =>
        (csv || "")
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean)
          .map((s) => ({ value: s.toLowerCase().replace(/\s+/g, "-"), label: s }));

      // Om schemat har egna värden → använd dem, annars default-lista
      const themes =
        container?.dataset.showStyleOptions === "false"
          ? []
          : container?.dataset.styleOptions
            ? parseCustomStyles(container.dataset.styleOptions)
            : [
                { value: "tecknat", label: "Tecknat" },
                { value: "vattenfarg", label: "Vattenfärg" },
                { value: "dromigt", label: "Drömmigt" },
                { value: "pop-art", label: "Pop Art" },
                { value: "vintage", label: "Vintage" },
                { value: "realistic", label: "Realistisk" },
                { value: "abstract", label: "Abstrakt" },
                { value: "minimalistic", label: "Minimalistisk" },
                { value: "cyberpunk", label: "Cyberpunk" },
                { value: "portratt", label: "Porträtt" },
                { value: "sketch", label: "Skiss" },
                { value: "oil-painting", label: "Oljemålning" },
                { value: "noir", label: "Noir" },
                { value: "fantasy", label: "Fantasy" },
                { value: "ghibli", label: "Ghibli" },
              ];

      console.debug("[AIGeneratorComponent] Schema settings loaded:", {
        generateButtonText,
        generatingText,
        promptPlaceholder,
        addToEditorText,
        errorText,
        previousImagesText,
      });

      // Helper function to get browser fingerprint for session recovery
      const getBrowserFingerprint = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        ctx.textBaseline = "top";
        ctx.font = "14px Arial";
        ctx.fillText("Browser fingerprint", 2, 2);

        const fingerprint = [
          navigator.userAgent,
          navigator.languages?.join(",") || navigator.language,
          screen.width + "x" + screen.height,
          new Date().getTimezoneOffset(),
          canvas.toDataURL(),
        ].join("|");

        // Create a simple hash
        let hash = 0;
        for (let i = 0; i < fingerprint.length; i++) {
          const char = fingerprint.charCodeAt(i);
          hash = (hash << 5) - hash + char;
          hash = hash & hash; // Convert to 32-bit integer
        }
        return Math.abs(hash).toString(36);
      };

      // Helper function to get unified session ID with backward compatibility
      const getUnifiedSession = () => {
        let session = localStorage.getItem("customizer_session");
        if (!session) {
          // Use backward-compatible format with dashes for existing images
          const timestamp = Date.now();
          const random = Math.random().toString(36).substr(2, 9);
          session = `session-${timestamp}-${random}`;
          localStorage.setItem("customizer_session", session);
        }
        // Also set ai-user-session to match for consistency
        localStorage.setItem("ai-user-session", session);
        return session;
      };

      // Load cached images on mount
      const loadCachedImages = useCallback(async () => {
        try {
          setIsLoadingCached(true);
          setLoadingCached(true);
          console.debug("[AIGeneratorComponent] Loading cached images for productId:", productId);

          const userSession = getUnifiedSession();
          console.debug("[AIGeneratorComponent] Using unified session for cached images:", userSession);

          const supabaseUrl = "https://fevkfaldkdxftapwojfs.supabase.co";
          const response = await fetch(`${supabaseUrl}/functions/v1/get-cached-images`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZldmtmYWxka2R4ZnRhcHdvamZzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEzOTkxNzcsImV4cCI6MjA2Njk3NTE3N30.n3oswnrS8Xbf82z6T5oOCvMSwkd2i3hYh9Szkc_cIn4",
            },
            body: JSON.stringify({
              userSession,
              // Temporarily remove generationType filter for debugging
            }),
          });

          console.debug("[AIGeneratorComponent] Response status:", response.status);
          if (response.ok) {
            const data = await response.json();
            console.debug("[AIGeneratorComponent] Response data:", data);
            console.debug("[AIGeneratorComponent] Cached images loaded:", data.images?.length || 0);
            setCachedImages(data.images || []);
          } else {
            const errorText = await response.text();
            console.error("[AIGeneratorComponent] Failed to load cached images:", response.status, errorText);
          }
        } catch (error) {
          console.error("[AIGeneratorComponent] Error loading cached images:", error);
        } finally {
          setLoadingCached(false);
          setIsLoadingCached(false);
        }
      }, [productId]);

      // Generation tracking to prevent duplicates
      const [generationTracker] = useState(() => new Set());
      const [isLoadingCached, setIsLoadingCached] = useState(false);

      // Proper debounced version to prevent multiple calls
      const debouncedLoadCachedImages = useCallback(() => {
        if (isLoadingCached) {
          console.debug("[AIGeneratorComponent] Already loading cached images, skipping");
          return;
        }

        // Clear any existing timeout
        if (window.cachedImagesTimeout) {
          clearTimeout(window.cachedImagesTimeout);
        }

        window.cachedImagesTimeout = setTimeout(() => {
          if (!isLoadingCached) {
            loadCachedImages();
          }
        }, 300);
      }, [loadCachedImages, isLoadingCached]);

      useEffect(() => {
        loadCachedImages();
      }, [loadCachedImages]);

      const handleGenerate = useCallback(async () => {
        if (!prompt.trim()) return;

        const currentGenerationId = `gen-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
        setGenerationId(currentGenerationId);

        setIsGenerating(true);
        setError(null);
        try {
          // Call AI generation via postMessage to iframe
          const iframe = document.querySelector(`#customizer-canvas-${productId} iframe`);
          if (iframe) {
            iframe.contentWindow.postMessage(
              {
                type: "ai:generate",
                prompt: prompt,
                theme: theme,
                orientation: orientation,
                generationId: currentGenerationId,
              },
              "*",
            );
          }

          onUpdate({ type: "ai-generate", prompt, theme, orientation });
        } catch (error) {
          console.error("AI generation error:", error);
          if (error.message.includes("SyntaxError") || error.message.includes("Unexpected token")) {
            setError("Server temporarily unavailable. Please try again in a moment.");
          } else {
            setError(error.message);
          }
          setIsGenerating(false);
        }
      }, [prompt, theme, orientation, productId, onUpdate]);

      // Listen for AI response
      useEffect(() => {
        const handleAIResponse = async (event) => {
          // Check if this response matches our current generation
          if (generationId && event.detail.generationId !== generationId) {
            console.debug(
              "[AIGeneratorComponent] Ignoring response for different generation:",
              event.detail.generationId,
              "expected:",
              generationId,
            );
            return;
          }

          if (event.detail.success) {
            setGeneratedImage(event.detail.imageUrl);
            setError(null);

            // Cache the generated image (only once per generation)
            if (generationId && !generationTracker.has(generationId)) {
              generationTracker.add(generationId);
              console.debug("[AIGeneratorComponent] Caching new generation:", generationId);

              try {
                const userSession = getUnifiedSession();
                console.debug("[AIGeneratorComponent] Caching image with unified session:", userSession);

                const supabaseUrl = "https://fevkfaldkdxftapwojfs.supabase.co";
                const response = await fetch(`${supabaseUrl}/functions/v1/cache-ai-image`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZldmtmYWxka2R4ZnRhcHdvamZzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEzOTkxNzcsImV4cCI6MjA2Njk3NTE3N30.n3oswnrS8Xbf82z6T5oOCvMSwkd2i3hYh9Szkc_cIn4",
                  },
                  body: JSON.stringify({
                    imageUrl: event.detail.imageUrl,
                    prompt: prompt,
                    theme: theme,
                    userSession: userSession,
                    generationType: "generated",
                    generationId: generationId,
                  }),
                });

                if (!response.ok) {
                  const errorData = await response.json();
                  console.error("[AIGeneratorComponent] Cache API error:", errorData);
                } else {
                  console.debug("[AIGeneratorComponent] Image cached successfully");
                  // Debounced reload to prevent multiple calls
                  debouncedLoadCachedImages();
                }
              } catch (cacheError) {
                console.error("[AIGeneratorComponent] Error caching image:", cacheError);
              }
            } else if (generationId) {
              console.debug("[AIGeneratorComponent] Generation already cached:", generationId);
            }
          } else {
            setError(event.detail.error);
          }
          setIsGenerating(false);
        };

        const aiBlock = document.querySelector(
          `[data-product-id="${productId}"][data-block-type="ai-generator"], [data-product-id="${productId}"][data-block-type="ai-image-generator"]`,
        );
        if (aiBlock) {
          aiBlock.addEventListener("ai:response", handleAIResponse);
        }

        return () => {
          if (aiBlock) {
            aiBlock.removeEventListener("ai:response", handleAIResponse);
          }
        };
      }, [productId, generationId, prompt, theme, debouncedLoadCachedImages]);

      const handleAddToEditor = useCallback(
        (imageUrl) => {
          if (imageUrl) {
            const iframe = document.querySelector(`#customizer-canvas-${productId} iframe`);
            if (iframe) {
              iframe.contentWindow.postMessage(
                {
                  type: "image:add",
                  imageUrl: imageUrl,
                },
                "*",
              );
            }
          }
        },
        [productId],
      );

      return React.createElement(
        "div",
        { className: "ai-generator-native" },
        // Cached images section (always show for debugging)
        React.createElement(
          "div",
          {
            className: "cached-images-section",
            style: { marginBottom: "20px" },
          },
          React.createElement(
            "h4",
            {
              style: {
                fontSize: "14px",
                fontWeight: "600",
                marginBottom: "12px",
                color: "#333",
              },
            },
            previousImagesText,
          ),
          loadingCached
            ? React.createElement(
                "div",
                {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "80px",
                    color: "#666",
                    fontSize: "14px",
                  },
                },
                "Loading...",
              )
            : cachedImages.length > 0
              ? React.createElement(
                  "div",
                  {
                    className: "cached-images-grid",
                    style: {
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
                      gap: "12px",
                      maxHeight: "200px",
                      overflowY: "auto",
                    },
                  },
                  cachedImages.slice(0, 8).map((img, index) =>
                    React.createElement(
                      "div",
                      {
                        key: img.id || index,
                        className: "cached-image-item",
                        style: {
                          position: "relative",
                          borderRadius: "6px",
                          overflow: "hidden",
                          border: "1px solid #e0e0e0",
                        },
                      },
                      React.createElement("img", {
                        src: img.cached_url,
                        alt: img.original_prompt
                          ? `Generated: ${img.original_prompt.substring(0, 30)}...`
                          : "Cached image",
                        style: {
                          width: "100%",
                          height: "80px",
                          objectFit: "cover",
                          cursor: "pointer",
                        },
                        onClick: () => handleAddToEditor(img.cached_url),
                      }),
                      React.createElement(
                        "button",
                        {
                          onClick: () => handleAddToEditor(img.cached_url),
                          style: {
                            position: "absolute",
                            bottom: "4px",
                            left: "4px",
                            right: "4px",
                            padding: "4px 6px",
                            backgroundColor: "rgba(16, 185, 129, 0.9)",
                            color: "White frame",
                            border: "Ingen ram",
                            borderRadius: "3px",
                            fontSize: "11px",
                            fontWeight: "500",
                            cursor: "pointer",
                            opacity: "0",
                            transition: "opacity 0.2s",
                          },
                          onMouseEnter: (e) => (e.currentTarget.style.opacity = "1"),
                          onMouseLeave: (e) => (e.currentTarget.style.opacity = "0"),
                        },
                        addToEditorText,
                      ),
                    ),
                  ),
                )
              : React.createElement(
                  "div",
                  {
                    style: {
                      color: "#666",
                      fontSize: "14px",
                      fontStyle: "italic",
                      textAlign: "center",
                      padding: "20px",
                      border: "1px dashed #ddd",
                      borderRadius: "6px",
                    },
                  },
                  "No previous images yet",
                ),
        ),
        React.createElement(
          "div",
          { className: "ai-input-group" },
          // Orientation selector
          React.createElement(
            "div",
            {
              style: { marginBottom: "12px" },
            },
            React.createElement(
              "label",
              {
                style: {
                  display: "block",
                  marginBottom: "6px",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#333",
                },
              },
              orientationLabel,
            ),
            React.createElement(
              "div",
              {
                style: {
                  display: "flex",
                  gap: "8px",
                },
              },
              React.createElement(
                "button",
                {
                  type: "button",
                  onClick: () => setOrientation("portrait"),
                  style: {
                    flex: 1,
                    padding: "8px 12px",
                    border: orientation === "portrait" ? "2px solid #007cba" : "1px solid #ddd",
                    borderRadius: "6px",
                    fontSize: "14px",
                    backgroundColor: orientation === "portrait" ? "#f0f9ff" : "White frame",
                    color: orientation === "portrait" ? "#007cba" : "#333",
                    cursor: "pointer",
                    fontWeight: orientation === "portrait" ? "600" : "400",
                  },
                },
                orientationPortraitText,
              ),
              React.createElement(
                "button",
                {
                  type: "button",
                  onClick: () => setOrientation("landscape"),
                  style: {
                    flex: 1,
                    padding: "8px 12px",
                    border: orientation === "landscape" ? "2px solid #007cba" : "1px solid #ddd",
                    borderRadius: "6px",
                    fontSize: "14px",
                    backgroundColor: orientation === "landscape" ? "#f0f9ff" : "White frame",
                    color: orientation === "landscape" ? "#007cba" : "#333",
                    cursor: "pointer",
                    fontWeight: orientation === "landscape" ? "600" : "400",
                  },
                },
                orientationLandscapeText,
              ),
            ),
          ),
          // Theme selector (conditional based on showStyleOptions)
          showStyleOptions &&
            React.createElement(
              "div",
              {
                style: { marginBottom: "12px" },
              },
              React.createElement(
                "label",
                {
                  style: {
                    display: "block",
                    marginBottom: "6px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333",
                  },
                },
                themeLabel,
              ),
              React.createElement(
                "select",
                {
                  value: theme,
                  onChange: (e) => setTheme(e.target.value),
                  style: {
                    width: "100%",
                    padding: "8px 12px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    fontSize: "14px",
                    backgroundColor: "White frame",
                  },
                },
                themes.map((t) =>
                  React.createElement(
                    "option",
                    {
                      key: t.value,
                      value: t.value,
                    },
                    t.label,
                  ),
                ),
              ),
            ),
          React.createElement("textarea", {
            value: prompt,
            onChange: (e) => setPrompt(e.target.value),
            placeholder: promptPlaceholder,
            className: "ai-prompt-input",
            style: {
              width: "100%",
              minHeight: "80px",
              padding: "12px",
              border: "1px solid #ddd",
              borderRadius: "6px",
              fontSize: "14px",
              resize: "vertical",
            },
          }),
          React.createElement(
            "div",
            {
              style: {
                marginTop: "12px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
              },
            },
            React.createElement(
              "button",
              {
                onClick: handleGenerate,
                disabled: isGenerating || !prompt.trim(),
                className: "ai-generate-btn",
                style: {
                  width: "100%",
                  padding: "12px",
                  backgroundColor: isGenerating || !prompt.trim() ? "#9ca3af" : "#10b981",
                  color: "White frame",
                  border: "Ingen ram",
                  borderRadius: "6px",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: isGenerating || !prompt.trim() ? "not-allowed" : "pointer",
                },
              },
              isGenerating ? generatingText : generateButtonText,
            ),

            // SVG Loading indicator next to button
            isGenerating &&
              React.createElement(
                "div",
                {
                  className: "generating-status",
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: "#666",
                    fontSize: "14px",
                  },
                },
                React.createElement("span", null, generatingText),
                React.createElement(
                  "svg",
                  {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "Ingen ram",
                    style: { animation: "spin 1s linear infinite" },
                  },
                  React.createElement("circle", {
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "#3b82f6",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeDasharray: "31.416",
                    strokeDashoffset: "31.416",
                  }),
                ),
              ),
          ),
        ),
        error &&
          React.createElement(
            "div",
            {
              style: { color: "#dc2626", marginTop: "8px", fontSize: "14px" },
            },
            errorText,
          ),
        generatedImage &&
          React.createElement(
            "div",
            {
              style: { marginTop: "16px" },
            },
            React.createElement("img", {
              src: generatedImage,
              alt: "Generated image",
              style: {
                width: "100%",
                height: orientation === "portrait" ? "160px" : "120px",
                objectFit: "cover",
                borderRadius: "6px",
                border: "1px solid #ddd",
                aspectRatio: orientation === "portrait" ? "9/16" : "16/9",
              },
            }),
            React.createElement(
              "button",
              {
                onClick: () => handleAddToEditor(generatedImage),
                style: {
                  marginTop: "8px",
                  padding: "8px 16px",
                  backgroundColor: "#10b981",
                  color: "White frame",
                  border: "Ingen ram",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                  display: "block",
                },
              },
              addToEditorText,
            ),
          ),
      );
    };

    // Image Modifier Component
    // Image Modifier Component
    this.ImageModifyComponent = function (props) {
      // ✅ SÄKER destructuring – inga fria "props" utanför komponenten
      const {
        productId,
        uploadButtonText,
        modifyButtonText,
        modifyingText,
        promptPlaceholder,
        addToEditorText,
        previousImagesText,
        styleLabel,
        stylePlaceholder,
        errorText,
        uploadRequiredText,
        fileFormatText,
      } = props || {};

      const { useState, useEffect } = window.React;

      const [isModifying, setIsModifying] = useState(false);
      const [processingStep, setProcessingStep] = useState("");
      const [progress, setProgress] = useState(0);
      const [modificationPrompt, setModificationPrompt] = useState("");
      const [stylePreset, setStylePreset] = useState("");
      const [uploadedImage, setUploadedImage] = useState(null);
      const [modifiedImage, setModifiedImage] = useState(null);
      const [cachedImages, setCachedImages] = useState([]);
      const [isLoadingCache, setIsLoadingCache] = useState(false);
      const [imageError, setImageError] = useState(null);
      const [originalOrientation, setOriginalOrientation] = useState(null);

      // Stabil userSession i localStorage
      const [userSession] = useState(() => {
        const stored = localStorage.getItem("userSession");
        if (stored) return stored;
        const newSession = `user_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        localStorage.setItem("userSession", newSession);
        return newSession;
      });

      // Tillgängliga stilpresets (oförändrat innehåll)
      const defaultPresets = [
        { value: "tecknat", label: "Tecknat" },
        { value: "vattenfarg", label: "Vattenfärg" },
        { value: "dromigt", label: "Drömmigt" },
        { value: "pop-art", label: "Pop Art" },
        { value: "vintage", label: "Vintage" },
        { value: "realistic", label: "Realistisk" },
        { value: "abstract", label: "Abstrakt" },
        { value: "minimalistic", label: "Minimalistisk" },
        { value: "cyberpunk", label: "Cyberpunk" },
        { value: "portratt", label: "Porträtt" },
        { value: "sketch", label: "Skiss" },
        { value: "oil-painting", label: "Oljemålning" },
        { value: "noir", label: "Noir" },
        { value: "fantasy", label: "Fantasy" },
        { value: "ghibli", label: "Ghibli" },
      ];

      const parseCustomStyles = (csv) =>
        (csv || "")
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean)
          .map((s) => ({ value: s.toLowerCase().replace(/\s+/g, "-"), label: s }));

      const stylePresets =
        props.showStyleOptions === false
          ? []
          : props.styleOptions
            ? parseCustomStyles(props.styleOptions)
            : defaultPresets;

      // Helper: Get image dimensions from URL
      const getImageDimensionsFromUrl = (src) => {
        return new Promise(async (resolve, reject) => {
          if (!src || typeof src !== 'string') {
            console.warn('[Orientation] Invalid image src:', src);
            reject(new Error('Invalid image source'));
            return;
          }
          
          const img = new Image();
          
          img.onload = () => {
            resolve({ width: img.naturalWidth, height: img.naturalHeight });
          };
          
          img.onerror = () => reject(new Error('Failed to load image'));
          
          if (src.startsWith('data:')) {
            img.src = src;
          } else {
            try {
              const res = await fetch(src);
              const blob = await res.blob();
              const objectUrl = URL.createObjectURL(blob);
              img.src = objectUrl;
              img.onload = () => {
                resolve({ width: img.naturalWidth, height: img.naturalHeight });
                URL.revokeObjectURL(objectUrl);
              };
            } catch (error) {
              img.crossOrigin = 'anonymous';
              img.src = src;
            }
          }
        });
      };

      // Helper: Determine orientation from dimensions
      const determineOrientation = (dims) => {
        if (dims.width === dims.height) return 'square';
        return dims.width > dims.height ? 'landscape' : 'portrait';
      };

      // Helper: CORS-safe rotation
      const rotateImage90Safe = (src) => {
        return new Promise(async (resolve, reject) => {
          try {
            const img = new Image();
            let objectUrl = null;

            const processImage = () => {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              
              if (!ctx) {
                reject(new Error('Failed to get canvas context'));
                return;
              }

          // Swap dimensions for 90° rotation
          canvas.width = img.naturalHeight;
          canvas.height = img.naturalWidth;

          // Rotate 90° counter-clockwise
          ctx.translate(canvas.width / 2, canvas.height / 2);
          ctx.rotate(-Math.PI / 2);
          ctx.drawImage(img, -img.naturalWidth / 2, -img.naturalHeight / 2);

              const dataUrl = canvas.toDataURL('image/png');
              
              if (objectUrl) URL.revokeObjectURL(objectUrl);
              resolve(dataUrl);
            };

            img.onload = processImage;
            img.onerror = () => {
              if (objectUrl) URL.revokeObjectURL(objectUrl);
              reject(new Error('Failed to load image for rotation'));
            };

            if (src.startsWith('data:')) {
              img.src = src;
            } else {
              try {
                const res = await fetch(src);
                const blob = await res.blob();
                objectUrl = URL.createObjectURL(blob);
                img.src = objectUrl;
              } catch (error) {
                img.crossOrigin = 'anonymous';
                img.src = src;
              }
            }
          } catch (error) {
            reject(error);
          }
        });
      };

      // Helper: Ensure orientation matches target
      const ensureOrientationMatch = async (src, targetOrientation) => {
        if (!src || typeof src !== 'string') {
          console.warn('[Orientation] Invalid src for orientation match:', src);
          return src;
        }
        
        if (!targetOrientation || targetOrientation === 'square') return src;

        try {
          let currentSrc = src;
          const dims = await getImageDimensionsFromUrl(currentSrc);
          let currentOrientation = determineOrientation(dims);

          console.debug('[Orientation] Checking:', { targetOrientation, currentOrientation, dims });

          // First rotation attempt
          if (currentOrientation !== targetOrientation && currentOrientation !== 'square') {
            console.debug('[Orientation] Rotating 90° (first attempt)');
            currentSrc = await rotateImage90Safe(currentSrc);
            const newDims = await getImageDimensionsFromUrl(currentSrc);
            currentOrientation = determineOrientation(newDims);
            console.debug('[Orientation] After first rotation:', { currentOrientation, newDims });
          }

          // Second rotation attempt if still mismatched (edge case)
          if (currentOrientation !== targetOrientation && currentOrientation !== 'square') {
            console.debug('[Orientation] Rotating 90° (second attempt - total 180°)');
            currentSrc = await rotateImage90Safe(currentSrc);
            const finalDims = await getImageDimensionsFromUrl(currentSrc);
            console.debug('[Orientation] After second rotation:', { orientation: determineOrientation(finalDims), finalDims });
          }

          return currentSrc;
        } catch (error) {
          console.error('[Orientation] Rotation failed:', error);
          return src; // Return original on error
        }
      };

      useEffect(() => {
        fetchCachedImages();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [userSession]);

      const fetchCachedImages = async () => {
        setIsLoadingCache(true);
        try {
          const response = await fetch("https://fevkfaldkdxftapwojfs.supabase.co/functions/v1/get-cached-images", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZldmtmYWxka2R4ZnRhcHdvamZzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEzOTkxNzcsImV4cCI6MjA2Njk3NTE3N30.n3oswnrS8Xbf82z6T5oOCvMSwkd2i3hYh9Szkc_cIn4",
            },
            body: JSON.stringify({
              userSession,
              generationType: "modified",
            }),
          });
          const data = await response.json();
          console.debug("[AIImageModify] Cached images response:", data);
          if (data.images) setCachedImages(data.images);
        } catch (error) {
          console.error("Error fetching cached images:", error);
        } finally {
          setIsLoadingCache(false);
        }
      };

      const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (file.size > 5 * 1024 * 1024) {
          setImageError("File size must be less than 5MB");
          return;
        }

        if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) {
          setImageError("Only JPG, PNG and WEBP files are supported");
          return;
        }

        setImageError(null);
        const reader = new FileReader();
        reader.onload = async (e) => {
          const dataUrl = e.target.result;
          setUploadedImage(dataUrl);
          
          // Determine and save original orientation
          try {
            const dims = await getImageDimensionsFromUrl(dataUrl);
            const orientation = determineOrientation(dims);
            setOriginalOrientation(orientation);
            console.debug('[Orientation] Original image:', { orientation, dims });
          } catch (error) {
            console.error('[Orientation] Failed to determine original orientation:', error);
          }
        };
        reader.readAsDataURL(file);
      };

      const modifyImage = async () => {
        if (!uploadedImage) {
          setImageError(uploadRequiredText);
          return;
        }

        if (!stylePreset) {
          setImageError("Please select a style");
          return;
        }

        setIsModifying(true);
        setProgress(0);
        setProcessingStep("Uploading image...");
        setImageError(null);

        try {
          const response = await fetch("https://fevkfaldkdxftapwojfs.supabase.co/functions/v1/modify-ai-image", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              baseImageUrl: uploadedImage,
              modificationPrompt: modificationPrompt || "",
              stylePreset,
              intensity: 0.8,
              userSession,
            }),
          });

          const data = await response.json();

          if (data.error) {
            throw new Error(data.error);
          }

          const serverUrl = data.modifiedImageUrl || data.imageUrl;
          
          // Correct orientation immediately
          console.debug('[Orientation] AI result received, correcting orientation...');
          const correctedDataUrl = await ensureOrientationMatch(serverUrl, originalOrientation);
          
          let finalImageUrl = serverUrl;
          
          // If we rotated the image, upload the corrected version
          if (correctedDataUrl !== serverUrl) {
            console.debug('[Orientation] Uploading corrected image to storage...');
            setProcessingStep('Sparar korrigerad bild...');
            
            const uploadResponse = await fetch("https://fevkfaldkdxftapwojfs.supabase.co/functions/v1/upload-corrected-image", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZldmtmYWxka2R4ZnRhcHdvamZzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEzOTkxNzcsImV4cCI6MjA2Njk3NTE3N30.n3oswnrS8Xbf82z6T5oOCvMSwkd2i3hYh9Szkc_cIn4"
              },
              body: JSON.stringify({
                dataUrl: correctedDataUrl,
                userSession: userSession
              })
            });
            
            const uploadData = await uploadResponse.json();
            
            if (uploadData?.publicUrl) {
              finalImageUrl = uploadData.publicUrl;
              console.debug('[Orientation] Corrected image uploaded:', finalImageUrl);
            } else {
              console.warn('[Orientation] Failed to upload corrected image, using original');
            }
          }
          
          setModifiedImage(correctedDataUrl);
          
          // Refresh cached images list (already cached by modify-ai-image function)
          console.log('Refreshing cached images...');
          await fetchCachedImages();
          setProcessingStep("Complete!");
          setProgress(100);
        } catch (error) {
          console.error("Error modifying image:", error);
          setImageError(error.message || errorText);
        } finally {
          setIsModifying(false);
        }
      };

      const handleAddToEditor = async (imageUrl) => {
        console.debug("[AIImageModify] Adding image to editor:", imageUrl);
        if (imageUrl) {
          const iframe = document.querySelector(`#customizer-canvas-${productId} iframe`);
          console.debug("[AIImageModify] Found iframe:", iframe);
          if (iframe && iframe.contentWindow) {
            console.debug("[AIImageModify] Sending postMessage to iframe");
            iframe.contentWindow.postMessage(
              {
                type: "image:add",
                imageUrl: imageUrl,
              },
              "*",
            );
          } else {
            console.error("[AIImageModify] No iframe found or contentWindow not accessible");
          }
        }
      };

      const ReactEl = window.React.createElement;

      return ReactEl(
        "div",
        { className: "ai-modifier-native" },

        // Cached images section
        ReactEl(
          "div",
          {
            className: "cached-images-section",
            style: { marginBottom: "20px" },
          },
          ReactEl(
            "h4",
            {
              style: {
                fontSize: "14px",
                fontWeight: "600",
                marginBottom: "12px",
                color: "#333",
              },
            },
            previousImagesText,
          ),
          isLoadingCache
            ? ReactEl(
                "div",
                {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "80px",
                    color: "#666",
                    fontSize: "14px",
                  },
                },
                "Loading...",
              )
            : cachedImages.length > 0
              ? ReactEl(
                  "div",
                  {
                    className: "cached-images-grid",
                    style: {
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
                      gap: "12px",
                      maxHeight: "200px",
                      overflowY: "auto",
                    },
                  },
                  cachedImages.slice(0, 8).map((img, index) => {
                    return ReactEl(
                      "div",
                      {
                        key: img.id || index,
                        className: "cached-image-item",
                        style: {
                          position: "relative",
                          borderRadius: "6px",
                          overflow: "hidden",
                          border: "1px solid #e0e0e0",
                        },
                      },
                      ReactEl("img", {
                        src: img.cached_url,
                        alt: img.original_prompt
                          ? `Modified: ${img.original_prompt.substring(0, 30)}...`
                          : "Cached image",
                        style: {
                          width: "100%",
                          height: "80px",
                          objectFit: "cover",
                          cursor: "pointer",
                        },
                        onClick: () => handleAddToEditor(img.cached_url),
                      }),
                      ReactEl(
                        "button",
                        {
                          onClick: () => handleAddToEditor(img.cached_url),
                          style: {
                            position: "absolute",
                            bottom: "4px",
                            left: "4px",
                            right: "4px",
                            padding: "4px 6px",
                            backgroundColor: "rgba(16, 185, 129, 0.9)",
                            color: "#fff", // ✅ var "White frame" → korrekt färg
                            border: "none", // ✅ var "Ingen ram" → korrekt border
                            borderRadius: "3px",
                            fontSize: "11px",
                            fontWeight: "500",
                            cursor: "pointer",
                            opacity: "0",
                            transition: "opacity 0.2s",
                          },
                          onMouseEnter: (e) => (e.currentTarget.style.opacity = "1"),
                          onMouseLeave: (e) => (e.currentTarget.style.opacity = "0"),
                        },
                        addToEditorText,
                      ),
                    );
                  }),
                )
              : ReactEl(
                  "div",
                  {
                    style: {
                      color: "#666",
                      fontSize: "14px",
                      fontStyle: "italic",
                      textAlign: "center",
                      padding: "20px",
                      border: "1px dashed #ddd",
                      borderRadius: "6px",
                    },
                  },
                  "No previous images",
                ),
        ),

        // Upload Section
        ReactEl(
          "div",
          { style: { marginBottom: "16px" } },
          ReactEl(
            "button",
            {
              onClick: () => {
                const fileInput = document.querySelector(`input[type="file"][data-upload="${productId}"]`);
                if (fileInput) {
                  fileInput.click();
                }
              },
              style: {
                width: "100%",
                padding: "12px",
                backgroundColor: "#10b981",
                color: "#fff", // ✅ var "White frame"
                border: "none", // ✅ var "Ingen ram"
                borderRadius: "6px",
                fontSize: "14px",
                fontWeight: "500",
                cursor: "pointer",
                display: "block",
              },
            },
            uploadButtonText,
          ),
          ReactEl("input", {
            type: "file",
            accept: "image/jpeg,image/png,image/webp",
            onChange: handleImageUpload,
            style: { display: "none" },
            "data-upload": productId,
          }),
          ReactEl(
            "p",
            {
              style: { fontSize: "12px", color: "#6b7280", margin: "8px 0 0 0", textAlign: "center" },
            },
            fileFormatText,
          ),
        ),

        // Uploaded Image Preview
        uploadedImage &&
          ReactEl(
            "div",
            { style: { marginBottom: "16px", textAlign: "center" } },
            ReactEl("img", {
              src: uploadedImage,
              alt: "Uploaded image",
              style: {
                width: "100%",
                maxHeight: "200px",
                objectFit: "cover",
                borderRadius: "8px",
                border: "1px solid #e5e7eb",
              },
            }),
          ),

        // Style Selection
        ReactEl(
          "div",
          { style: { marginBottom: "16px" } },
          ReactEl(
            "label",
            {
              style: { display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "500", color: "#374151" },
            },
            styleLabel,
          ),
          ReactEl(
            "select",
            {
              value: stylePreset,
              onChange: (e) => setStylePreset(e.target.value),
              style: {
                width: "100%",
                padding: "8px 12px",
                border: "1px solid #d1d5db",
                borderRadius: "6px",
                fontSize: "14px",
                backgroundColor: "#fff", // ✅ var "White frame"
              },
            },
            ReactEl("option", { value: "" }, stylePlaceholder),
            stylePresets.map((style) => ReactEl("option", { key: style.value, value: style.value }, style.label)),
          ),
        ),

        // Prompt Input (Optional)
        ReactEl(
          "div",
          { style: { marginBottom: "16px" } },
          ReactEl("textarea", {
            value: modificationPrompt,
            onChange: (e) => setModificationPrompt(e.target.value),
            placeholder: promptPlaceholder,
            style: {
              width: "100%",
              height: "80px",
              padding: "8px 12px",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              fontSize: "14px",
              resize: "vertical",
              fontFamily: "system-ui, -apple-system, sans-serif",
            },
          }),
        ),

        // Modify Button
        ReactEl(
          "button",
          {
            onClick: modifyImage,
            disabled: isModifying || !uploadedImage || !stylePreset,
            style: {
              width: "100%",
              padding: "12px",
              backgroundColor: isModifying || !uploadedImage || !stylePreset ? "#9ca3af" : "#10b981",
              color: "#fff", // ✅ var "White frame"
              border: "none", // ✅ var "Ingen ram"
              borderRadius: "6px",
              fontSize: "14px",
              fontWeight: "500",
              cursor: isModifying || !uploadedImage || !stylePreset ? "not-allowed" : "pointer",
              marginBottom: "16px",
            },
          },
          isModifying ? modifyingText : modifyButtonText,
        ),

        // Progress
        isModifying &&
          ReactEl(
            "div",
            { style: { marginBottom: "16px" } },
            ReactEl("div", { style: { fontSize: "14px", color: "#6b7280", marginBottom: "8px" } }, processingStep),
            ReactEl(
              "div",
              {
                style: {
                  width: "100%",
                  height: "4px",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "2px",
                  overflow: "hidden",
                },
              },
              ReactEl("div", {
                style: {
                  width: `${progress}%`,
                  height: "100%",
                  backgroundColor: "#10b981",
                  transition: "width 0.3s ease",
                },
              }),
            ),
          ),

        // Error Message
        imageError &&
          ReactEl(
            "div",
            {
              style: { color: "#dc2626", marginBottom: "16px", fontSize: "14px" },
            },
            imageError,
          ),

        // Modified Image Result
        modifiedImage &&
          ReactEl(
            "div",
            { style: { marginTop: "16px" } },
            ReactEl("img", {
              src: modifiedImage,
              alt: "Modified image",
              style: {
                width: "100%",
                maxHeight: "200px",
                objectFit: "cover",
                borderRadius: "8px",
                border: "1px solid #e5e7eb",
              },
            }),
            ReactEl(
              "button",
              {
                onClick: () => handleAddToEditor(modifiedImage),
                style: {
                  marginTop: "8px",
                  padding: "8px 16px",
                  backgroundColor: "#10b981",
                  color: "#fff", // ✅ var "White frame"
                  border: "none", // ✅ var "Ingen ram"
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                  display: "block",
                },
              },
              addToEditorText,
            ),
          ),
      );
    };

    // Controls Component
    this.ControlsComponent = function ({
      productId,
      showTextControls,
      showBackgroundControls,
      showOrientationControls,
      onUpdate,
    }) {
      const [activeTab, setActiveTab] = useState("text");
      const [textColor, setTextColor] = useState("#000000");
      const [fontSize, setFontSize] = useState(24);
      const [fontFamily, setFontFamily] = useState("Arial");
      const [backgroundColor, setBackgroundColor] = useState("#ffffff");
      const [orientation, setOrientation] = useState("portrait");
      const [textInput, setTextInput] = useState("");
      const [selectedLayerId, setSelectedLayerId] = useState(null);
      const [isEditingText, setIsEditingText] = useState(false);

      // Font options array
      const fontOptions = [
        "Arial",
        "Helvetica",
        "Times New Roman",
        "Courier New",
        "Verdana",
        "Georgia",
        "Palatino",
        "Garamond",
        "Bookman",
        "Comic Sans MS",
        "Trebuchet MS",
        "Arial Black",
        "Impact",
      ];

      // Get schema texts from data attributes
      const container = document.querySelector(
        `[data-product-id="${productId}"][data-block-type="customizer-controls"]`,
      );
      const addTextButtonText = container?.dataset.addTextButtonText || "Add Text";
      const updateTextButtonText = container?.dataset.updateTextButtonText || "Update Text";
      const textColorLabel = container?.dataset.textColorLabel || "Text Color";
      const fontLabel = container?.dataset.fontLabel || "Font";
      const fontSizeLabel = container?.dataset.fontSizeLabel || "Font Size";
      const backgroundColorLabel = container?.dataset.backgroundColorLabel || "Background Color";
      const orientationLabel = container?.dataset.orientationLabel || "Orientation";
      const portraitText = container?.dataset.portraitText || "Portrait";
      const landscapeText = container?.dataset.landscapeText || "Landscape";
      const textPlaceholder = container?.dataset.textPlaceholder || "Enter your text here...";

      console.debug("[ControlsComponent] Schema settings loaded:", {
        addTextButtonText,
        updateTextButtonText,
        textColorLabel,
        fontLabel,
        fontSizeLabel,
        backgroundColorLabel,
        orientationLabel,
        portraitText,
        landscapeText,
        textPlaceholder,
        showTextControls,
        showBackgroundControls,
        showOrientationControls,
      });

      console.debug("[ControlsComponent] All data attributes:", container?.dataset);

      const tabs = [];
      if (showTextControls) tabs.push({ id: "text", label: "Text" });
      if (showBackgroundControls) tabs.push({ id: "background", label: "Background" });

      // Message listener for layer selection from iframe and DOM events
      useEffect(() => {
        const handleMessage = (event) => {
          if (event.data.type === "layer:selected") {
            // Handle both payload formats: event.data.layer or event.data directly
            const payload = event.data || {};
            const layer = payload.layer || payload;

            console.debug("[ControlsComponent] Received layer:selected via postMessage:", layer);

            if (layer && layer.type === "text") {
              setSelectedLayerId(layer.id);
              setIsEditingText(true);
              setTextInput(layer.text || layer.content || "");
              setTextColor(layer.color || layer.textColor || "#000000");
              setFontFamily(layer.fontFamily || "Arial");
              setFontSize(layer.fontSize || 24);
            } else {
              setSelectedLayerId(null);
              setIsEditingText(false);
              // Clear text controls when no layer is selected
              setTextInput("");
              setTextColor("#000000");
              setFontFamily("Arial");
              setFontSize(24);
            }
          }
        };

        const handleControlsSync = (event) => {
          const layer = event.detail;
          console.debug("[ControlsComponent] Received layer via DOM event:", layer);

          if (layer && layer.type === "text") {
            setSelectedLayerId(layer.id);
            setIsEditingText(true);
            setTextInput(layer.text || layer.content || "");
            setTextColor(layer.color || layer.textColor || "#000000");
            setFontFamily(layer.fontFamily || "Arial");
            setFontSize(layer.fontSize || 24);
          } else {
            setSelectedLayerId(null);
            setIsEditingText(false);
            // Clear text controls when no layer is selected
            setTextInput("");
            setTextColor("#000000");
            setFontFamily("Arial");
            setFontSize(24);
          }
        };

        window.addEventListener("message", handleMessage);
        document.addEventListener("customizer:controls:sync", handleControlsSync);

        return () => {
          window.removeEventListener("message", handleMessage);
          document.removeEventListener("customizer:controls:sync", handleControlsSync);
        };
      }, []);

      const handleAddText = useCallback(() => {
        if (!textInput.trim()) return;

        const iframe = document.querySelector(`#customizer-canvas-${productId} iframe`);
        if (iframe) {
          if (isEditingText && selectedLayerId) {
            // Update existing text layer
            iframe.contentWindow.postMessage(
              {
                type: "text:update",
                layerId: selectedLayerId,
                text: textInput,
                color: textColor,
                fontFamily: fontFamily,
                fontSize: fontSize,
              },
              "*",
            );
            console.debug("[ControlsComponent] Updating existing text layer:", {
              layerId: selectedLayerId,
              text: textInput,
            });
          } else {
            // Add new text layer
            iframe.contentWindow.postMessage(
              {
                type: "text:add",
                text: textInput,
                color: textColor,
                fontFamily: fontFamily,
                fontSize: fontSize,
                zIndex: 1000,
              },
              "*",
            );
            console.debug("[ControlsComponent] Adding new text with properties:", {
              text: textInput,
              color: textColor,
              fontFamily,
              fontSize,
            });
            setTextInput(""); // Clear input after adding new text
          }
        }
      }, [textInput, textColor, fontFamily, fontSize, isEditingText, selectedLayerId, productId]);

      const handleTextColorChange = useCallback(
        (color) => {
          setTextColor(color);
          if (isEditingText && selectedLayerId) {
            const iframe = document.querySelector(`#customizer-canvas-${productId} iframe`);
            if (iframe) {
              iframe.contentWindow.postMessage(
                {
                  type: "text:update",
                  layerId: selectedLayerId,
                  color: color,
                },
                "*",
              );
            }
          }
        },
        [productId, isEditingText, selectedLayerId],
      );

      const handleFontFamilyChange = useCallback(
        (font) => {
          setFontFamily(font);
          if (isEditingText && selectedLayerId) {
            const iframe = document.querySelector(`#customizer-canvas-${productId} iframe`);
            if (iframe) {
              iframe.contentWindow.postMessage(
                {
                  type: "text:update",
                  layerId: selectedLayerId,
                  fontFamily: font,
                },
                "*",
              );
            }
          }
        },
        [productId, isEditingText, selectedLayerId],
      );

      const handleFontSizeChange = useCallback(
        (size) => {
          setFontSize(size);
          if (isEditingText && selectedLayerId) {
            const iframe = document.querySelector(`#customizer-canvas-${productId} iframe`);
            if (iframe) {
              iframe.contentWindow.postMessage(
                {
                  type: "text:update",
                  layerId: selectedLayerId,
                  fontSize: size,
                },
                "*",
              );
            }
          }
        },
        [productId, isEditingText, selectedLayerId],
      );

      const handleBackgroundColorChange = useCallback(
        (color) => {
          setBackgroundColor(color);
          const iframe = document.querySelector(`#customizer-canvas-${productId} iframe`);
          if (iframe) {
            iframe.contentWindow.postMessage(
              {
                type: "background:color-change",
                backgroundColor: color,
              },
              "*",
            );
          }
        },
        [productId],
      );

      const handleOrientationChange = useCallback(
        (newOrientation) => {
          setOrientation(newOrientation);
          const iframe = document.querySelector(`#customizer-canvas-${productId} iframe`);
          if (iframe) {
            iframe.contentWindow.postMessage(
              {
                type: "product:orientation-change",
                orientation: newOrientation,
              },
              "*",
            );
          }
        },
        [productId],
      );

      return React.createElement(
        "div",
        { className: "customizer-controls-native" },
        // Tab navigation
        React.createElement(
          "div",
          {
            className: "controls-tabs",
            style: {
              display: "flex",
              borderBottom: "1px solid #eee",
              marginBottom: "16px",
            },
          },
          tabs.map((tab) =>
            React.createElement(
              "button",
              {
                key: tab.id,
                onClick: () => setActiveTab(tab.id),
                className: `tab-btn ${activeTab === tab.id ? "active" : ""}`,
                style: {
                  padding: "10px 16px",
                  border: "Ingen ram",
                  backgroundColor: activeTab === tab.id ? "#f5f5f5" : "transparent",
                  borderBottom: activeTab === tab.id ? "2px solid #007cba" : "2px solid transparent",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                },
              },
              tab.label,
            ),
          ),
        ),

        // Tab content
        React.createElement(
          "div",
          { className: "tab-content" },
          activeTab === "text" &&
            React.createElement(
              "div",
              { className: "text-controls" },
              React.createElement(
                "div",
                {
                  className: "control-group",
                  style: { marginBottom: "16px" },
                },
                React.createElement(
                  "label",
                  {
                    style: { display: "block", marginBottom: "6px", fontSize: "14px", fontWeight: "500" },
                  },
                  addTextButtonText,
                ),
                React.createElement(
                  "div",
                  {
                    style: { display: "flex", gap: "8px" },
                  },
                  React.createElement("input", {
                    type: "text",
                    value: textInput,
                    onChange: (e) => setTextInput(e.target.value),
                    placeholder: textPlaceholder,
                    style: {
                      flex: 1,
                      padding: "8px 12px",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      fontSize: "14px",
                    },
                  }),
                  React.createElement(
                    "button",
                    {
                      onClick: handleAddText,
                      disabled: !textInput.trim(),
                      style: {
                        padding: "8px 16px",
                        backgroundColor: textInput.trim() ? "#10b981" : "#ccc",
                        color: "white",
                        border: "none",
                        borderRadius: "4px",
                        cursor: textInput.trim() ? "pointer" : "not-allowed",
                        fontSize: "14px",
                        fontWeight: "500",
                      },
                    },
                    isEditingText ? updateTextButtonText : addTextButtonText,
                  ),
                ),
              ),
              React.createElement(
                "div",
                {
                  className: "control-group",
                  style: { marginBottom: "16px" },
                },
                React.createElement(
                  "label",
                  {
                    style: { display: "block", marginBottom: "6px", fontSize: "14px", fontWeight: "500" },
                  },
                  textColorLabel + " & " + fontLabel,
                ),
                React.createElement(
                  "div",
                  {
                    style: { display: "flex", gap: "12px", alignItems: "center" },
                  },
                  React.createElement("input", {
                    type: "color",
                    value: textColor,
                    onChange: (e) => handleTextColorChange(e.target.value),
                    style: {
                      width: "60px",
                      height: "30px",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      cursor: "pointer",
                    },
                  }),
                  React.createElement(
                    "select",
                    {
                      value: fontFamily,
                      onChange: (e) => handleFontFamilyChange(e.target.value),
                      style: {
                        flex: 1,
                        padding: "6px 8px",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        fontSize: "14px",
                        backgroundColor: "white",
                      },
                    },
                    fontOptions.map((font) =>
                      React.createElement(
                        "option",
                        {
                          key: font,
                          value: font,
                          style: { fontFamily: font },
                        },
                        font,
                      ),
                    ),
                  ),
                ),
              ),
              React.createElement(
                "div",
                {
                  className: "control-group",
                },
                React.createElement(
                  "label",
                  {
                    style: { display: "block", marginBottom: "6px", fontSize: "14px", fontWeight: "500" },
                  },
                  fontSizeLabel,
                ),
                React.createElement("input", {
                  type: "range",
                  min: "12",
                  max: "72",
                  value: fontSize,
                  onChange: (e) => handleFontSizeChange(parseInt(e.target.value)),
                  style: {
                    width: "100%",
                    marginBottom: "6px",
                  },
                }),
                React.createElement(
                  "span",
                  {
                    style: { fontSize: "12px", color: "#666" },
                  },
                  fontSize + "px",
                ),
              ),
            ),
          activeTab === "background" &&
            React.createElement(
              "div",
              { className: "background-controls" },
              React.createElement(
                "div",
                {
                  className: "control-group",
                },
                React.createElement(
                  "label",
                  {
                    style: { display: "block", marginBottom: "6px", fontSize: "14px", fontWeight: "500" },
                  },
                  backgroundColorLabel,
                ),
                React.createElement("input", {
                  type: "color",
                  value: backgroundColor,
                  onChange: (e) => handleBackgroundColorChange(e.target.value),
                  style: {
                    width: "60px",
                    height: "30px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    cursor: "pointer",
                  },
                }),
              ),
            ),
        ),
      );
    };

    // Controls Load Component (duplicate of ControlsComponent with image upload at top)
    this.ControlsLoadComponent = function ({
      productId,
      showTextControls,
      showBackgroundControls,
      showOrientationControls,
      onUpdate,
    }) {
      const [activeTab, setActiveTab] = React.useState("text");
      const [textColor, setTextColor] = React.useState("#000000");
      const [fontSize, setFontSize] = React.useState(24);
      const [fontFamily, setFontFamily] = React.useState("Arial");
      const [backgroundColor, setBackgroundColor] = React.useState("#ffffff");
      const [orientation, setOrientation] = React.useState("portrait");
      const [textInput, setTextInput] = React.useState("");
      const [selectedLayerId, setSelectedLayerId] = React.useState(null);
      const [isEditingText, setIsEditingText] = React.useState(false);
      const [uploadedImage, setUploadedImage] = React.useState(null);

      // Läs textvärden direkt från data-* på containern (robust & utan props)
      const hostEl =
        document.getElementById(`customizer-controls-load-${productId}`) ||
        document.querySelector(`[data-block-type="customizer-controls-load"][data-product-id="${productId}"]`);

      const btnText = hostEl?.dataset.uploadImageButtonText || "Ladda upp bild";
      const fmtText = hostEl?.dataset.fileFormatText || "Stödda format: JPG, PNG, WEBP (max 5MB)";

      // ---- BILDLADDNING (nytt block överst) ----
      const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) {
          alert("Endast JPG, PNG eller WEBP stöds");
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          setUploadedImage(e.target.result);

          // Lägg direkt till i editorn
          const iframe = document.querySelector(`#customizer-canvas-${productId} iframe`);
          if (iframe && iframe.contentWindow) {
            iframe.contentWindow.postMessage(
              {
                type: "image:add",
                imageUrl: e.target.result,
              },
              "*",
            );
          }
        };
        reader.readAsDataURL(file);
      };

      // ---- Resten är exakt samma som ControlsComponent ----
      const fontOptions = [
        "Arial",
        "Helvetica",
        "Times New Roman",
        "Courier New",
        "Verdana",
        "Georgia",
        "Palatino",
        "Garamond",
        "Bookman",
        "Comic Sans MS",
        "Trebuchet MS",
        "Arial Black",
        "Impact",
      ];

      // Render
      return React.createElement(
        "div",
        { className: "customizer-controls-native" },
        // Nytt block högst upp
        React.createElement(
          "div",
          { style: { marginBottom: "16px" } },
          React.createElement(
            "button",
            {
              onClick: () => document.getElementById(`upload-input-${productId}`).click(),
              style: {
                width: "100%",
                padding: "12px",
                backgroundColor: "#10b981",
                color: "white",
                border: "none",
                borderRadius: "6px",
                fontSize: "14px",
                fontWeight: "500",
                cursor: "pointer",
              },
            },
            btnText,
          ),
          React.createElement("input", {
            id: `upload-input-${productId}`,
            type: "file",
            accept: "image/jpeg,image/png,image/webp",
            style: { display: "none" },
            onChange: handleImageUpload,
          }),
          React.createElement(
            "p",
            {
              style: { fontSize: "12px", color: "#6b7280", margin: "8px 0 0 0", textAlign: "center" },
            },
            fmtText,
          ),
          uploadedImage &&
            React.createElement(
              "div",
              { style: { marginTop: "12px" } },
              React.createElement("img", {
                src: uploadedImage,
                alt: "Uploaded",
                style: {
                  width: "100%",
                  maxHeight: "200px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  border: "1px solid #e5e7eb",
                },
              }),
            ),
        ),

        // 👇 Här renderar vi samma tabbar och kontroller som i ControlsComponent
        // (kopiera in samma return-body från din nuvarande ControlsComponent)
      );
    };

    // Product Config Component
    this.ProductConfigComponent = function ({
      productId,
      showProductType,
      showOrientation,
      showFrameSelector,
      onUpdate,
    }) {
      const [productType, setProductType] = useState("poster");
      const [orientation, setOrientation] = useState("portrait");
      const [frame, setFrame] = useState("Ingen ram");

      // Get schema texts from data attributes
      const container = document.querySelector(`[data-product-id="${productId}"][data-block-type="product-config"]`);
      const productTypeLabel = container?.dataset.productTypeLabel || "Product Type";
      const posterText = container?.dataset.posterText || "Poster";
      const canvasText = container?.dataset.canvasText || "Canvas";
      const orientationLabel = container?.dataset.orientationLabel || "Orientation";
      const portraitText = container?.dataset.portraitText || "Portrait";
      const landscapeText = container?.dataset.landscapeText || "Landscape";
      const frameLabel = container?.dataset.frameLabel || "Frame";
      const frameNoneText = container?.dataset.frameNoneText || "No Frame";
      const frameWhiteText = container?.dataset.frameWhiteText || "White Frame";
      const frameBlackText = container?.dataset.frameBlackText || "Black Frame";
      const frameWoodText = container?.dataset.frameWoodText || "Wood Frame";
      const frameDarkwoodText = container?.dataset.frameDarkwoodText || "Dark Wood Frame";

      const handleProductTypeChange = useCallback(
        (newType) => {
          setProductType(newType);
          // Notify iframe about product type change
          const iframe = document.querySelector(`#customizer-canvas-${productId} iframe`);
          if (iframe) {
            iframe.contentWindow.postMessage(
              {
                type: "product:type-change",
                productType: newType,
              },
              "*",
            );
          }
          onUpdate({ type: "product-type-change", productType: newType });
        },
        [productId, onUpdate],
      );

      const handleOrientationChange = useCallback(
        (newOrientation) => {
          setOrientation(newOrientation);
          // Notify iframe about orientation change
          const iframe = document.querySelector(`#customizer-canvas-${productId} iframe`);
          if (iframe) {
            iframe.contentWindow.postMessage(
              {
                type: "product:orientation-change",
                orientation: newOrientation,
              },
              "*",
            );
          }
          onUpdate({ type: "orientation-change", orientation: newOrientation });
        },
        [productId, onUpdate],
      );

      const handleFrameChange = useCallback(
        (newFrame) => {
          setFrame(newFrame);
          // Notify iframe about frame change
          const iframe = document.querySelector(`#customizer-canvas-${productId} iframe`);
          if (iframe) {
            iframe.contentWindow.postMessage(
              {
                type: "frame:change",
                frame: newFrame,
              },
              "*",
            );
          }
          onUpdate({ type: "frame-change", frame: newFrame });
        },
        [productId, onUpdate],
      );

      return React.createElement(
        "div",
        { className: "product-config-native" },
        showProductType === "true" &&
          React.createElement(
            "div",
            {
              className: "config-group",
              style: { marginBottom: "20px" },
            },
            React.createElement(
              "label",
              {
                style: { display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "500" },
              },
              productTypeLabel,
            ),
            React.createElement(
              "div",
              { style: { display: "flex", gap: "8px" } },
              React.createElement(
                "button",
                {
                  onClick: () => handleProductTypeChange("poster"),
                  style: {
                    padding: "10px 20px",
                    backgroundColor: productType === "poster" ? "#007cba" : "#f5f5f5",
                    color: productType === "poster" ? "White frame" : "#333",
                    border: "1px solid " + (productType === "poster" ? "#007cba" : "#ddd"),
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "500",
                  },
                },
                posterText,
              ),
              React.createElement(
                "button",
                {
                  onClick: () => handleProductTypeChange("canvas"),
                  style: {
                    padding: "10px 20px",
                    backgroundColor: productType === "canvas" ? "#007cba" : "#f5f5f5",
                    color: productType === "canvas" ? "White frame" : "#333",
                    border: "1px solid " + (productType === "canvas" ? "#007cba" : "#ddd"),
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "500",
                  },
                },
                canvasText,
              ),
            ),
          ),

        showOrientation === "true" &&
          React.createElement(
            "div",
            {
              className: "config-group",
              style: { marginBottom: "20px" },
            },
            React.createElement(
              "label",
              {
                style: { display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "500" },
              },
              orientationLabel,
            ),
            React.createElement(
              "div",
              { style: { display: "flex", gap: "8px" } },
              React.createElement(
                "button",
                {
                  onClick: () => handleOrientationChange("portrait"),
                  style: {
                    padding: "8px 16px",
                    backgroundColor: orientation === "portrait" ? "#007cba" : "#f5f5f5",
                    color: orientation === "portrait" ? "White frame" : "#333",
                    border: "1px solid " + (orientation === "portrait" ? "#007cba" : "#ddd"),
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "500",
                  },
                },
                portraitText,
              ),
              React.createElement(
                "button",
                {
                  onClick: () => handleOrientationChange("landscape"),
                  style: {
                    padding: "8px 16px",
                    backgroundColor: orientation === "landscape" ? "#007cba" : "#f5f5f5",
                    color: orientation === "landscape" ? "White frame" : "#333",
                    border: "1px solid " + (orientation === "landscape" ? "#007cba" : "#ddd"),
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "500",
                  },
                },
                landscapeText,
              ),
            ),
          ),

        showFrameSelector === "true" &&
          React.createElement(
            "div",
            { className: "config-group" },
            React.createElement(
              "label",
              {
                style: { display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "500" },
              },
              frameLabel,
            ),
            React.createElement(
              "select",
              {
                value: frame,
                onChange: (e) => handleFrameChange(e.target.value),
                style: {
                  width: "100%",
                  padding: "8px 12px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  fontSize: "14px",
                  backgroundColor: "White frame",
                },
              },
              React.createElement("option", { value: "Ingen ram" }, frameNoneText),
              React.createElement("option", { value: "White frame" }, frameWhiteText),
              React.createElement("option", { value: "Wood frame" }, frameWoodText),
              React.createElement("option", { value: "Dark wood frame" }, frameDarkwoodText),
              React.createElement("option", { value: "Black frame" }, frameBlackText),
            ),
          ),
      );
    };
  }

  renderBlock(blockId, blockType, props) {
    const { React, ReactDOM } = window;

    if (!this.reactLoaded || !React || !ReactDOM) {
      console.error("React not loaded");
      return;
    }

    const container = document.getElementById(blockId);
    if (!container) {
      console.error(`Container not found: ${blockId}`);
      return;
    }

    const toBool = (v, d = false) => (v == null ? d : String(v).toLowerCase() === "true");

    let Component;

    switch (blockType) {
      case "customizer-canvas":
        Component = this.CanvasComponent;
        break;
      case "ai-image-generator":
      case "ai-generator":
        Component = this.AIGeneratorComponent;
        // Clear placeholder before mounting
        container.innerHTML = "";
        break;
      case "ai-image-modify":
        Component = this.ImageModifyComponent;
        // Extract props from data attributes
        props.uploadButtonText = container.dataset.uploadButtonText || "Ladda upp bild";
        props.modifyButtonText = container.dataset.modifyButtonText || "Modify Image";
        props.modifyingText = container.dataset.modifyingText || "Modifying...";
        props.promptPlaceholder =
          container.dataset.promptPlaceholder || "Describe how you want to modify the image (optional)...";
        props.addToEditorText = container.dataset.addToEditorText || "Add to Editor";
        props.previousImagesText = container.dataset.previousImagesText || "Previous Modified Images";
        props.styleLabel = container.dataset.styleLabel || "Style";
        props.stylePlaceholder = container.dataset.stylePlaceholder || "Select a style...";
        props.errorText = container.dataset.errorText || "Error modifying image. Please try again.";
        props.uploadRequiredText = container.dataset.uploadRequiredText || "Please upload an image first";
        props.fileFormatText = container.dataset.fileFormatText || "Supported formats: JPG, PNG, WEBP (max 5MB)";
        // Clear placeholder before mounting
        props.styleOptions = container.dataset.styleOptions || ""; // CSV eller tom
        props.showStyleOptions = (container.dataset.showStyleOptions || "true").toLowerCase() === "true";
        container.innerHTML = "";
        break;
      case "customizer-controls":
        Component = this.ControlsComponent;
        // Coerce boolean dataset values and clear placeholder
        props.showTextControls = toBool(container.dataset.showTextControls, true);
        props.showBackgroundControls = toBool(container.dataset.showBackgroundControls, true);
        props.showLayerControls = toBool(container.dataset.showLayerControls, true);
        props.showOrientationControls = toBool(container.dataset.showOrientationControls, true);
        container.innerHTML = "";
        break;
      case "customizer-controls-load":
        ReactDOM.render(React.createElement(this.ControlsLoadComponent, props), document.getElementById(blockId));
        break;
      case "product-config":
        Component = this.ProductConfigComponent;
        // Coerce boolean dataset values and clear placeholder
        props.showProductType = toBool(container.dataset.showProductType, true);
        props.showOrientation = toBool(container.dataset.showOrientation, true);
        props.showFrameSelector = toBool(container.dataset.showFrameSelector, true);
        container.innerHTML = "";
        break;
      default:
        console.error(`Unknown block type: ${blockType}`);
        return;
    }

    console.debug("[CustomizerNativeLoader] renderBlock", { blockId, blockType, props });

    // Render React component
    const reactElement = React.createElement(Component, props);

    if (ReactDOM.createRoot) {
      // React 18
      const root = ReactDOM.createRoot(container);
      root.render(reactElement);
      this.componentInstances.set(blockId, { root, type: blockType });
    } else {
      // React 17
      ReactDOM.render(reactElement, container);
      this.componentInstances.set(blockId, { container, type: blockType });
    }
  }

  updateState(newState) {
    this.customizerState = { ...this.customizerState, ...newState };

    // Notify all components about state change
    this.componentInstances.forEach((instance, blockId) => {
      const event = new CustomEvent("customizer:state-change", {
        detail: { blockId, state: this.customizerState },
      });
      document.dispatchEvent(event);
    });
  }

  setupDesignDataSync() {
    // Listen for design updates from React components
    document.addEventListener("customizer:design-update", (event) => {
      console.debug("[CustomizerNativeLoader] Received design update:", event.detail);
      this.updateDesignData(event.detail);
    });

    // Listen for layer selection events from React customizer
    document.addEventListener("customizer:layer:selected", (event) => {
      console.debug("[CustomizerNativeLoader] Received layer selection:", event.detail);
      this.updateControlsFromLayer(event.detail);
    });

    console.debug("[CustomizerNativeLoader] Design data sync listener initialized");
  }

  updateControlsFromLayer(layerData) {
    // Dispatch event for ControlsComponent to handle layer selection
    console.debug("[CustomizerNativeLoader] Dispatching controls sync event with layer:", layerData);
    const controlsSyncEvent = new CustomEvent("customizer:controls:sync", {
      detail: layerData,
    });
    document.dispatchEvent(controlsSyncEvent);
  }

  updateDesignData(data) {
    // Update design data from React components
    this.designData = {
      motifs: data.motifs || [],
      canvasSize: data.canvasSize || null,
      productType: data.productType || "poster",
      timestamp: new Date().toISOString(),
      ...data,
    };

    console.debug("[CustomizerNativeLoader] Design data updated:", {
      motifCount: this.designData.motifs?.length || 0,
      hasCanvasSize: !!this.designData.canvasSize,
      hasMotifs: !!this.designData.motifs?.length,
    });
  }

  getDesignData() {
    console.debug("[CustomizerNativeLoader] getDesignData called, returning:", {
      hasData: !!this.designData,
      motifCount: this.designData.motifs?.length || 0,
      hasCanvasSize: !!this.designData.canvasSize,
    });
    return this.designData;
  }

  setDesignData(data) {
    this.designData = data;
  }
}

// Initialize when script loads
window.CustomizerNativeLoader = new CustomizerNativeLoader();
